import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { BehaviorSubject, Observable, Subject } from 'rxjs/Rx';
import { apiUrl, apiUrlcommon } from '../app.config';
import { ShohiyoHikazei } from '../models/plan/ShohiyoHikazei';
import { LeaseCalcPriceParam } from './../models/lease/leaseCalcPriceParam';
import { LeaseCalculatedValue } from './../models/lease/leaseCalculatedValue';
import {
  CompanyList,
  ShohiyouHikazei,
  ShohiyouKazei
} from './../models/plan/companylist.model';
import { CreditCompany } from './../models/plan/creditCompany';
import { EnvironmentSetting } from './../models/plan/environmentSetting';
import { KappuGankin } from './../models/plan/kappuGankin';
import { Kyotens } from './../models/plan/kyotens';
import { LoanCalculatedValue } from './../models/plan/loanCalculatedValue';
import { LoanPaymentCount } from './../models/plan/loanPaymentCount';
import { LoanPlan } from './../models/plan/loanPlan';
import { LoanRate } from './../models/plan/loanRate';
import {
  MaintenanceLeaseItem,
  ScheduleList
} from './../models/plan/maintenanceLeaseItem';
import { NewKappuGankin } from './../models/plan/newKappuGankin';
import { Sueoki } from './../models/plan/sueoki';
// import { Flags } from '../models/plan/flags';
// import { promise } from 'protractor';
import { DataService } from './data.service';
import { UtilService } from './util.service';
import { car } from '../models/plan/car';

@Injectable()
export class PlanService {
  static headers = new Headers({ 'Content-Type': 'application/json' });

  // null:未読込、true:新車デリバリー、false:新車市場
  _isNewCarDeliveryUser:boolean = null;

  fromSaveOnly = new BehaviorSubject<any>('');
  chosenMakerChange = new BehaviorSubject<any>('');
  chosenModelChange = new BehaviorSubject<any>('');
  chosenSoukouValue = new BehaviorSubject<any>('');
  chosenBikouValue = new BehaviorSubject<any>('');
  chosenItenValue = new BehaviorSubject<number>(0);
  chosenColorSelected = new BehaviorSubject<any>('');
  chosenShiftSelected = new BehaviorSubject<any>('');
  chosenFuelSelected = new BehaviorSubject<any>(0);
  chosenShashuSelected = new BehaviorSubject<any>(0);
  chosenClearState = new BehaviorSubject<any>('');
  chosenClearAll = new BehaviorSubject<any>('');
  chosenJidouValue = new BehaviorSubject<any>('');
  chosenJidoushazei = new BehaviorSubject<any>('');
  chosenJuuryouValue = new BehaviorSubject<any>('');
  chosenGradeSelected = new BehaviorSubject<any>('');
  chosenDealerItemSelected = new BehaviorSubject<any>('');
  chosenDealerItemUnselected = new BehaviorSubject<any>('');
  chosenGradeSelectedforDOP = new BehaviorSubject<any>('');
  chosenKataruiDetail = new BehaviorSubject<any>('');
  chosenKatashikiDetail = new BehaviorSubject<any>('');
  chosenPriceZk = new BehaviorSubject<any>('');
  // chosenKatashiki = new BehaviorSubject<any>('');
  // chosenShadaiNo = new BehaviorSubject<any>('');
  chosenPriceZn = new BehaviorSubject<any>('');
  chosenShakenKigenKbn = new BehaviorSubject<any>('');
  chosenKyoten = new BehaviorSubject<Kyotens>({
    kyotenCd: '',
    kyotenNm: ''
  });
  changeKyoten = new BehaviorSubject<boolean>(false);
  chosenInsurance = new BehaviorSubject<any>('');
  chosenClearFlag = new BehaviorSubject<any>('');
  chosenMakerOption = new BehaviorSubject<any>('');
  baseYearMonth = new BehaviorSubject<string>('');
  chosenNewCarData = new BehaviorSubject<any>('');
  chosenNewCarColor = new BehaviorSubject<any>('');
  chosenKazeiShohiyou = new BehaviorSubject<any>('');
  newcarDefaultShohiyouCd = new BehaviorSubject<any>('');
  usedcarDefaultShohiyouCd = new BehaviorSubject<any>('');
  remarkBikou1 = new BehaviorSubject<any>('');
  remarkBikou2 = new BehaviorSubject<any>('');
  getNiihokinData = new BehaviorSubject<any>(null);
  getNiihokinChecked = new BehaviorSubject<any>(null);
  currentGrandTotal = new BehaviorSubject<number>(0);
  grandTotalLoan = new BehaviorSubject<number>(0);
  grandTotalLease = new BehaviorSubject<number>(0);
  hontaiZk = new BehaviorSubject<number>(0);
  hontaiZn = new BehaviorSubject<number>(0);
  chosenHiKazeiShohiyou = new BehaviorSubject<any>('');
  setMopDataFilter = new BehaviorSubject<any>('');
  setPlanMaker = new BehaviorSubject<any>('');
  setPlanDealer = new BehaviorSubject<any>('');
  kataruiSelected = new BehaviorSubject<any>('');
  katashikiSelected = new BehaviorSubject<any>('');
  chosenPrefCd = new BehaviorSubject<any>('');
  jibaisekiKikanIkkagetsuKasan = new BehaviorSubject<any>('');
  deleteFlagDOP = new BehaviorSubject<any>('');
  deleteFlagHOP = new BehaviorSubject<any>('');
  deleteFlagMOP = new BehaviorSubject<any>('');
  setMOPItem = new BehaviorSubject<any>('');
  deleteFlagSpecialColor = new BehaviorSubject<any>(false);
  flagNewCarColorDetail = new BehaviorSubject<any>(false);
  passingPlanUsedcar = new BehaviorSubject<any>('');

  chosenjibaiseki = new BehaviorSubject<any>(null);
  chosenjuuryouzeiPayment = new BehaviorSubject<any>(null);
  chosenPaymentMethod = new BehaviorSubject<any>(null);
  chosenPaymentMethod2 = new BehaviorSubject<any>(null);
  chosenPaymentMethod3 = new BehaviorSubject<any>(null);
  chosenPaymentMethodCurrent = new BehaviorSubject<any>(null);
  // shutokuChange = new BehaviorSubject<number>(0);

  // loan
  chosenCreditCompany = new BehaviorSubject<number>(0);

  loanCreditCompanyOne = new BehaviorSubject<number>(0);
  loanCreditCompanyTwo = new BehaviorSubject<number>(0);
  loanchosenLoanPlanOne = new BehaviorSubject<number>(0);
  loanchosenLoanPlanTwo = new BehaviorSubject<number>(0);

  chosenLoanPlan = new BehaviorSubject<number>(0);
  chosenShinpanCode = new BehaviorSubject<string>('');
  chosenShinpanRenban = new BehaviorSubject<number>(0);
  loanGankinHasuuKbn = new BehaviorSubject<number>(0);
  isPlanOneActivated = new BehaviorSubject<boolean>(false);
  isPlanTwoActivated = new BehaviorSubject<boolean>(false);
  loanOneAtamakin = new BehaviorSubject<number>(0);
  loanTwoAtamakin = new BehaviorSubject<number>(0);
  loanPlanOneName = new BehaviorSubject<string>('');
  loanPlanTwoName = new BehaviorSubject<string>('');
  loanOneMonthlyPayment = new BehaviorSubject<number>(0);
  loanTwoMonthlyPayment = new BehaviorSubject<number>(0);
  loanOneFirstPayment = new BehaviorSubject<number>(0);
  loanTwoFirstPayment = new BehaviorSubject<number>(0);
  loanOneBonus = new BehaviorSubject<number>(0);
  loanTwoBonus = new BehaviorSubject<number>(0);
  loanOneBonusCount = new BehaviorSubject<number>(0);
  loanTwoBonusCount = new BehaviorSubject<number>(0);
  loanOnePaymentCount = new BehaviorSubject<number>(0);
  loanTwoPaymentCount = new BehaviorSubject<number>(0);
  loanOneFirstPaymentYM = new BehaviorSubject<string>('');
  loanTwoFirstPaymentYM = new BehaviorSubject<string>('');
  loanOneKappuTesuuRyou = new BehaviorSubject<number>(0);
  loanTwoKappuTesuuRyou = new BehaviorSubject<number>(0);
  loanOneBonusMonthOne = new BehaviorSubject<number>(0);
  loanTwoBonusMonthOne = new BehaviorSubject<number>(0);
  loanOneBonusMonthTwo = new BehaviorSubject<number>(0);
  loanTwoBonusMonthTwo = new BehaviorSubject<number>(0);
  loanOneShinpanRenban = new BehaviorSubject<number>(0);
  loanTwoShinpanRenban = new BehaviorSubject<number>(0);
  loanOneShinpanCode = new BehaviorSubject<string>('');
  loanTwoShinpanCode = new BehaviorSubject<string>('');
  loanOneFirstBonusPaymentYM = new BehaviorSubject<string>('');
  loanTwoFirstBonusPaymentYM = new BehaviorSubject<string>('');
  loanOneIsSueoki = new BehaviorSubject<number>(0);
  loanTwoIsSueoki = new BehaviorSubject<number>(0);
  loanOneSueokiPrice = new BehaviorSubject<number>(0);
  loanTwoSueokiPrice = new BehaviorSubject<number>(0);
  loanOneSueokiRitsu = new BehaviorSubject<number>(0);
  loanTwoSueokiRitsu = new BehaviorSubject<number>(0);

  isShowBalloon = new BehaviorSubject<boolean>(false);

  setNewCarColorDetail = new BehaviorSubject<any>('');

  /// loan2

  chosenCreditCompany2 = new BehaviorSubject<number>(0);
  chosenLoanPlan2 = new BehaviorSubject<number>(0);
  chosenShinpanCode2 = new BehaviorSubject<string>('');
  chosenShinpanRenban2 = new BehaviorSubject<number>(0);
  loanOneAtamakin2 = new BehaviorSubject<number>(0);
  loanTwoAtamakin2 = new BehaviorSubject<number>(0);
  loanPlanOneName2 = new BehaviorSubject<string>('');
  loanPlanTwoName2 = new BehaviorSubject<string>('');
  loanOneMonthlyPayment2 = new BehaviorSubject<number>(0);
  loanTwoMonthlyPayment2 = new BehaviorSubject<number>(0);
  loanOneFirstPayment2 = new BehaviorSubject<number>(0);
  loanTwoFirstPayment2 = new BehaviorSubject<number>(0);
  loanOneBonus2 = new BehaviorSubject<number>(0);
  loanTwoBonus2 = new BehaviorSubject<number>(0);
  loanOneBonusCount2 = new BehaviorSubject<number>(0);
  loanTwoBonusCount2 = new BehaviorSubject<number>(0);
  isShowBalloon2 = new BehaviorSubject<boolean>(false);

  loanOneFirstPaymentYM2 = new BehaviorSubject<string>('');
  loanTwoFirstPaymentYM2 = new BehaviorSubject<string>('');
  loanOneKappuTesuuRyou2 = new BehaviorSubject<number>(0);
  loanTwoKappuTesuuRyou2 = new BehaviorSubject<number>(0);
  loanOneBonusMonthOne2 = new BehaviorSubject<number>(0);
  loanTwoBonusMonthOne2 = new BehaviorSubject<number>(0);
  loanOneBonusMonthTwo2 = new BehaviorSubject<number>(0);
  loanTwoBonusMonthTwo2 = new BehaviorSubject<number>(0);
  loanOneShinpanRenban2 = new BehaviorSubject<number>(0);
  loanTwoShinpanRenban2 = new BehaviorSubject<number>(0);
  loanOneShinpanCode2 = new BehaviorSubject<string>('');
  loanTwoShinpanCode2 = new BehaviorSubject<string>('');
  loanOneFirstBonusPaymentYM2 = new BehaviorSubject<string>('');
  loanTwoFirstBonusPaymentYM2 = new BehaviorSubject<string>('');
  loanOneIsSueoki2 = new BehaviorSubject<number>(0);
  loanTwoIsSueoki2 = new BehaviorSubject<number>(0);
  loanOneSueokiPrice2 = new BehaviorSubject<number>(0);
  loanTwoSueokiPrice2 = new BehaviorSubject<number>(0);
  loanOneSueokiRitsu2 = new BehaviorSubject<number>(0);
  loanTwoSueokiRitsu2 = new BehaviorSubject<number>(0);

  loanOnePaymentCount2 = new BehaviorSubject<number>(0);
  loanTwoPaymentCount2 = new BehaviorSubject<number>(0);

  /// loan3
  chosenCreditCompany3 = new BehaviorSubject<number>(0);
  chosenLoanPlan3 = new BehaviorSubject<number>(0);
  chosenShinpanCode3 = new BehaviorSubject<string>('');
  chosenShinpanRenban3 = new BehaviorSubject<number>(0);
  loanOneAtamakin3 = new BehaviorSubject<number>(0);
  loanTwoAtamakin3 = new BehaviorSubject<number>(0);
  loanPlanOneName3 = new BehaviorSubject<string>('');
  loanPlanTwoName3 = new BehaviorSubject<string>('');
  loanOneMonthlyPayment3 = new BehaviorSubject<number>(0);
  loanTwoMonthlyPayment3 = new BehaviorSubject<number>(0);
  loanOneFirstPayment3 = new BehaviorSubject<number>(0);
  loanTwoFirstPayment3 = new BehaviorSubject<number>(0);
  loanOneBonus3 = new BehaviorSubject<number>(0);
  loanTwoBonus3 = new BehaviorSubject<number>(0);
  loanOneBonusCount3 = new BehaviorSubject<number>(0);
  loanTwoBonusCount3 = new BehaviorSubject<number>(0);
  isShowBalloon3 = new BehaviorSubject<boolean>(false);

  loanOneFirstPaymentYM3 = new BehaviorSubject<string>('');
  loanTwoFirstPaymentYM3 = new BehaviorSubject<string>('');
  loanOneKappuTesuuRyou3 = new BehaviorSubject<number>(0);
  loanTwoKappuTesuuRyou3 = new BehaviorSubject<number>(0);
  loanOneBonusMonthOne3 = new BehaviorSubject<number>(0);
  loanTwoBonusMonthOne3 = new BehaviorSubject<number>(0);
  loanOneBonusMonthTwo3 = new BehaviorSubject<number>(0);
  loanTwoBonusMonthTwo3 = new BehaviorSubject<number>(0);
  loanOneShinpanRenban3 = new BehaviorSubject<number>(0);
  loanTwoShinpanRenban3 = new BehaviorSubject<number>(0);
  loanOneShinpanCode3 = new BehaviorSubject<string>('');
  loanTwoShinpanCode3 = new BehaviorSubject<string>('');
  loanOneFirstBonusPaymentYM3 = new BehaviorSubject<string>('');
  loanTwoFirstBonusPaymentYM3 = new BehaviorSubject<string>('');
  loanOneIsSueoki3 = new BehaviorSubject<number>(0);
  loanTwoIsSueoki3 = new BehaviorSubject<number>(0);
  loanOneSueokiPrice3 = new BehaviorSubject<number>(0);
  loanTwoSueokiPrice3 = new BehaviorSubject<number>(0);
  loanOneSueokiRitsu3 = new BehaviorSubject<number>(0);
  loanTwoSueokiRitsu3 = new BehaviorSubject<number>(0);

  loanOnePaymentCount3 = new BehaviorSubject<number>(0);
  loanTwoPaymentCount3 = new BehaviorSubject<number>(0);

  // lease
  shutokuZei = new BehaviorSubject<number>(0);

  leaseOneTabSelect = new BehaviorSubject<number>(1);

  /////// loadplan1 ///////////
  gradeSelectedplan = new BehaviorSubject<any>(null);

  ///////// notax ////////
  datachosennotax = new BehaviorSubject<any>(null);
  /////////////////////////////

  //////////// taxation ////////////////
  datachosennotaxation = new BehaviorSubject<any>(null);

  kazeiPaymentOne = new BehaviorSubject<any>(null);
  // kazeiPaymentTwo = new BehaviorSubject<any>(null);
  hikazeiPaymentOne = new BehaviorSubject<any>(null);
  // hikazeiPaymentTwo = new BehaviorSubject<any>(null);
  //////////////////////////////
  isInitialPlan = false;
  isInitialLease = false;

  // prefCd: string = localStorage.getItem("prefCd");
  soubiData: any[] = [];
  selectPaymentWay = new BehaviorSubject<number>(null);

  leaseShohiyouKazei = new BehaviorSubject<Array<ShohiyouKazei>>([]);
  leaseShohiyouKazei_2 = new BehaviorSubject<Array<ShohiyouKazei>>([]);
  leaseShohiyouHikazei = new BehaviorSubject<Array<ShohiyouHikazei>>([]);
  leaseShohiyouHikazei_2 = new BehaviorSubject<Array<ShohiyouHikazei>>([]);

  leaseShohiyouKazei2 = new BehaviorSubject<Array<ShohiyouKazei>>([]);
  leaseShohiyouHikazei2 = new BehaviorSubject<Array<ShohiyouHikazei>>([]);

  leaseShohiyouKazei3 = new BehaviorSubject<Array<ShohiyouKazei>>([]);
  leaseShohiyouHikazei3 = new BehaviorSubject<Array<ShohiyouHikazei>>([]);

  shohiyouKazeiPrice = new BehaviorSubject<number>(0);
  shohiyouHikaazeiPrice = new BehaviorSubject<number>(0);
  discountPrice = new BehaviorSubject<number>(0);
  sumHop = new BehaviorSubject<number>(0);
  sumDop = new BehaviorSubject<number>(0);
  sumMop = new BehaviorSubject<number>(0);

  customernamesub = new BehaviorSubject<any>(null);
  switchCustomer = new BehaviorSubject<any>(null);

  ResponseStatus;
  plantab = 1;
  hikazeiPlanTab = new BehaviorSubject<number>(0);
  taxRate = new BehaviorSubject<string>('100');

  grade: any = null;
  loanTabs: number = 1;
  loanTabs2: number = 1;
  loanTabs3: number = 1;

  setShitadori = new BehaviorSubject<any>(0);
  // setShitadori2 = new BehaviorSubject<any>(0);
  // setShitadori3 = new BehaviorSubject<any>(0);
  setCar1ShitadoriKbn = new BehaviorSubject<number>(1);
  setCar2ShitadoriKbn = new BehaviorSubject<number>(1);
  resetloan = new BehaviorSubject<boolean>(false);

  //// usedcar////
  isNewCar = new BehaviorSubject<number>(1);
  // allFlags = new BehaviorSubject<any>({
  //   newCar: '0',
  //   importCar: '0',
  //   keiyon: '1',
  //   shaken: '1',
  //   kengaitouruku: '0',
  //   shitadori: '0',
  //   loan: '0'
  // });

  allFlags = new BehaviorSubject<any>(null);
  kazeiFlags = new BehaviorSubject<any>(null);
  hikazeiFlags = new BehaviorSubject<any>(null);

  switchLoanDOP = new BehaviorSubject<string>('ZK');
  loanMonth = new BehaviorSubject<number>(24);
  switchPriceShohiyo = new BehaviorSubject<string>('ZK');

  jibaisekiObject = new BehaviorSubject<any>(null);

  // kazei tab
  hikazeiOptionTab1 = new BehaviorSubject<any[]>([]);
  hikazeiOptionTab2 = new BehaviorSubject<any[]>([]);
  // kazei tab2
  selectHikazei = new BehaviorSubject<any>(null);
  selectKazei = new BehaviorSubject<any>(null);
  // selectBoxKazei
  selectBoxKazei = new BehaviorSubject<any>(null);
  selectBoxHikazei = new BehaviorSubject<any>(null);
  saveSelectKazei = new BehaviorSubject<any>(null);
  saveSelectHikazei = new BehaviorSubject<any>(null);
  selectSagyoName: Array<ScheduleList>;
  // dialog state
  hopDialogState = new BehaviorSubject<boolean>(false);
  dialogState = new BehaviorSubject<boolean>(false);
  mopDialogState = new BehaviorSubject<boolean>(false);
  tradeinDialogstateOne = new BehaviorSubject<boolean>(false);
  tradeinDialogstateTwo = new BehaviorSubject<boolean>(false);
  flagsSaved = new BehaviorSubject<any>(null);
  changeShohiyou = new BehaviorSubject<boolean>(true);
  flagsUsedCar = new BehaviorSubject<any>(null);
  setShohiyou = new Subject<any>();
  pagecheck = new BehaviorSubject<boolean>(false);
  laborRatePrice = new BehaviorSubject<number>(0);
  unsaveLaborRate = new BehaviorSubject<number>(0);
  savedLaborRatePrice = new BehaviorSubject<number>(0);
  changeLaborRate = new BehaviorSubject<boolean>(false);
  isLaborSave = new BehaviorSubject<boolean>(false);
  environmentSetting = new BehaviorSubject<number>(0);
  laborPriceExceed = new Subject<number>();
  sumDealerChange = new Subject();
  defaultShohiyouList: ShohiyouKazei[] = [];
  defaultHikazeiList: ShohiyoHikazei[] = [];
  recycleDialogstate = new BehaviorSubject<boolean>(false);
  kazeiDialogstate = new BehaviorSubject<boolean>(false);
  hikazeiDialogstate = new BehaviorSubject<boolean>(false);
  taxDialogstate = new BehaviorSubject<boolean>(false);
  productKbn = new BehaviorSubject<number>(0);

  constructor(
    private http: Http,
    private router: Router,
    private _data: DataService,
    private _util: UtilService
  ) {}
  setFlags(flag: any) {
    this.allFlags.next(flag);
  }

  setTaxRate(tax: string) {
    this.taxRate.next(tax);
  }

  setMakerSelected(maker: any) {
    this.chosenMakerChange.next(maker); // send to plan-car-search
  }
  setModelSelected(model: any) {
    this.chosenModelChange.next(model); // send to plan-car-search
  }
  setSoukouValue(soukou: any) {
    this.chosenSoukouValue.next(soukou);
  }
  setBikouValue(bikou: any) {
    this.chosenBikouValue.next(bikou);
  }
  setItenValue(iten: number) {
    this.chosenItenValue.next(iten);
  }
  setColorSelected(color: any) {
    this.chosenColorSelected.next(color); // send to plan-car-search
  }
  setShiftSelected(shift: any) {
    this.chosenShiftSelected.next(shift); // send to plan-car-search
  }
  setFuelSelected(fuel: any) {
    this.chosenFuelSelected.next(fuel); // send to plan-car-search
  }
  setShashuSelected(shashu: any) {
    this.chosenShashuSelected.next(shashu); // send to plan-car-search
  }
  setClearState(state: any) {
    this.chosenClearState.next(state);
  }
  setClearAll(state: any) {
    this.chosenClearAll.next(state);
  }
  setJuuryouValue(value: any) {
    this.chosenJuuryouValue.next(value);
  }
  setJidouValue(value: any) {
    this.chosenJidouValue.next(value);
  }
  setGradeSelected(grade: any) {
    this.chosenGradeSelected.next(grade);
  }
  setDealerItem(data: any) {
    this.chosenDealerItemSelected.next([...data]);
  }
  unsetDealerItem(data: any) {
    this.chosenDealerItemUnselected.next([...data]);
  }
  setGradeSelectedForDOP(grade: any) {
    // send to dealer-option
    this.chosenGradeSelectedforDOP.next(grade);
  }

  setgradeValueForDOP(grade) {
    this.grade = grade;
  }

  getGradeValueForDOP() {
    return this.grade;
  }

  setLoanTabs(tab) {
    this.loanTabs = tab;
    // console.log(this.loanTabs);
  }

  getLoanTabs() {
    return this.loanTabs;
  }

  setLoanTabs2(tab) {
    this.loanTabs2 = tab;
    // console.log(this.loanTabs);
  }

  getLoanTabs2() {
    return this.loanTabs2;
  }

  setLoanTabs3(tab) {
    this.loanTabs3 = tab;
    // console.log(this.loanTabs);
  }

  getLoanTabs3() {
    return this.loanTabs3;
  }

  setDefaultShohiyouList(shohiyouList: ShohiyouKazei[]) {
    this.defaultShohiyouList = shohiyouList;
  }

  getDefaultShohiyouList() {
    return this.defaultShohiyouList;
  }

  setDefaultHikazeiList(hikazeiList: ShohiyoHikazei[]) {
    this.defaultHikazeiList = hikazeiList;
  }

  getDefaultHikazeiList() {
    return this.defaultHikazeiList;
  }

  setkataruiDetail(katarui: any) {
    this.chosenKataruiDetail.next(katarui);
  }
  setkatashikiDetail(katashiki: any) {
    this.chosenKatashikiDetail.next(katashiki);
  }
  // setKatashiki(ki: any) {
  //   this.chosenKatashiki.next(ki);
  // }
  // getShadaiNo(no: any) {
  //   this.chosenShadaiNo.next(no);
  // }
  setPriceZk(zk: any) {
    this.chosenPriceZk.next(zk);
  }
  setPriceZn(zn: any) {
    this.chosenPriceZn.next(zn);
  }
  setShakenKigen(kbn: any) {
    this.chosenShakenKigenKbn = kbn;
  }
  setInsurance(data: any) {
    this.chosenInsurance.next(data);
  }
  setClearFlag(data: any) {
    this.chosenClearFlag.next(data);
  }
  setMakerOption(makerOption: any) {
    this.chosenMakerOption.next(makerOption.slice());
  }

  setNewCarData(data: any) {
    this.chosenNewCarData.next(data);
  }
  setNewCarColor(data: any) {
    this.chosenNewCarColor.next(data);
  }
  setKazeiShohiyou(kazei: any) {
    this.chosenKazeiShohiyou.next(kazei);
  }

  setHiKazeiShohiyou(hikazei: any) {
    this.chosenHiKazeiShohiyou.next(hikazei);
  }

  getPlanUsedcar(value: number) {
    this.passingPlanUsedcar.next(value);
  }

  getMakersData(index?: number) {
    let url = `${apiUrlcommon}/newcar/makers/masterList?q=displayKbn=1`;
    if (index != null) {
      url += `,kanaIndex%3D${index}`;
    }
    return this.httpGet(url).share();
  }

  getMakers(index?: number) {
    let url = `${apiUrlcommon}/car/makers?q=displayKbn=1`;
    if (index != null) {
      url += `,kanaIndex%3D${index}`;
    }
    return this.httpGet(url).share();
  }

  // getMakerDataFilter(index: string) {
  //   const url = `${apiUrlcommon}/newcar/makers/masterList?q=displayKbn=1,kanaIndex%3D${index}`;
  //   return this.httpGet(url).share();
  // }

  getModelsData(makerCd: string, index?: number) {
    let url = `${apiUrlcommon}/newcar/models/masterList?q=makerCd=${makerCd}`;
    if (index != null) {
      url += `,kanaIndex%3D${index}`;
    }
    return this.httpGet(url).share();
  }

  // getModelDataFilter(makerCd: string, index: string) {
  //   const url = `${apiUrlcommon}/newcar/models/masterList?q=modelDisplayKbn%3D1,makerCd%3D${makerCd},kanaIndex%3D${index}`;
  //   return this.httpGet(url).share();
  // }

  getGradesData(makerCd: string, modelCd: string, kaiseiYm: string) {
    const url = `${apiUrlcommon}/newcar/grades/dialogList?q=makerCd%3D${makerCd},modelCd%3D${modelCd},kaiseiYm%3D${kaiseiYm}`;
    return this.httpGet(url).share();
  }

  getMakersDataCar(index?: number) {
    let url = `${apiUrlcommon}/car/makers?q=displayKbn%3D1`;
    if (index != null) {
      url += `,kanaIndex%3D${index}`;
    }
    // return this.httpGet(url).share();
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(url, { headers: headers })
      .map(response => {
        if (response.status != 200 && response.status != 204) {
          return 'データの取得に失敗しました';
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  // getMakerDataFilterCar(index: string) {
  //   const url = `${apiUrlcommon}/car/makers?q=displayKbn%3D1,kanaIndex%3D${index}`;
  //   // return this.httpGet(url).share();
  //   const headers = PlanService.headers;
  //   headers.set('auth', this._data.token);
  //   return this.http
  //     .get(url, { headers: headers })
  //     .map(response => {
  //       if (response.status != 200 && response.status != 204) {
  //         return 'データの取得に失敗しました';
  //       } else {
  //         return response.json();
  //       }
  //     })
  //     .catch(this.handleError.bind(this));
  // }

  getModelsDataCar(makerCd: string, index?: number) {
    let url = `${apiUrlcommon}/car/models?q=makerCd%3D${makerCd}`;
    if (index != null) {
      url += `,kanaIndex%3D${index}`;
    }
    // return this.httpGet(url).share();
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(url, { headers: headers })
      .map(response => {
        if (response.status != 200 && response.status != 204) {
          return 'データの取得に失敗しました';
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  // getModelDataFilterCar(makerCd: string, index: string) {
  //   const url = `${apiUrlcommon}/car/models?q=makerCd%3D${makerCd},kanaIndex%3D${index}`;
  //   // return this.httpGet(url).share();
  //   const headers = PlanService.headers;
  //   headers.set('auth', this._data.token);
  //   return this.http
  //     .get(url, { headers: headers })
  //     .map(response => {
  //       if (response.status != 200 && response.status != 204) {
  //         return 'データの取得に失敗しました';
  //       } else {
  //         return response.json();
  //       }
  //     })
  //     .catch(this.handleError.bind(this));
  // }

  getGradesDataCar(makerCd: string, modelCd: string) {
    const url = `${apiUrlcommon}/car/grades?q=makerCd%3D${makerCd},modelCd%3D${modelCd}`;
    // return this.httpGet(url);
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    return this.http
      .get(url, { headers: headers })
      .map(response => {
        if (response.status != 200 && response.status != 204) {
          return 'データの取得に失敗しました';
        } else {
          return response.json();
        }
      })
      .catch(this.handleError.bind(this));
  }

  getItenKubuns() {
    const url = `${apiUrlcommon}/etc/kbn/itenKubun`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  // getItenKubuns() {
  //   const url = `${apiUrlcommon}/etc/kbn/itenKubun`;
  //   return this.httpGet(url)
  //     .map((response: Response) => {
  //       if (response.status == 401) {
  //         this.deleteToken();
  //       } else {}
  //     })
  //     .catch(this.handleError.bind(this));
  // }

  getKeitooColors() {
    const url = `${apiUrlcommon}/car/keitooColors`;
    return this.httpGet(url);
  }

  getNewCarColor(
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ) {
    const url =
      `${apiUrlcommon}/newcar/grades/colors/search1/?q=` +
      `makerCd%3D${makerCd},modelCd%3D${modelCd},kaiseiYm%3D${kaiseiYm},gradeCd%3D${gradeCd}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getCarShifts() {
    const url = `${apiUrlcommon}/car/shifts`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getCarFuelList() {
    const url = `${apiUrl}/lease/kbn/fuel`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getCarShashuList() {
    const url = `${apiUrl}/lease/kbn/shashu`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getSoukouUnit() {
    const url = `${apiUrlcommon}/etc/kbn/soukouUnitKbn`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getSoukouBikou() {
    const url = `${apiUrlcommon}/etc/kbn/soukouBikouKbn`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getSharyouKubun() {
    const url = `${apiUrlcommon}/etc/kbn/sharyouKbn`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getJuuryouzeiKubuns() {
    const url = `${apiUrlcommon}/tax/juuryouzei/kubuns`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getJuuryoTaxTable(kbn: string, date: string) {
    const url = `${apiUrlcommon}/tax/juuryouzei/taxTable?q=kazeiKbn%3D${kbn},targetDate%3D${date}`;
    return this.httpGet(url);
  }

  getJuuryouzeiDeatil(weightTaxCd) {
    const url = `${apiUrlcommon}/tax/juuryouzei/detail/${weightTaxCd}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getJidoushazeiKubun() {
    const url = `${apiUrlcommon}/tax/jidoushazei/getKubuns`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getJidoushazeiDetail(jidoushazeiCd: string, kijunYmd: string = '') {
    let url = `${apiUrlcommon}/tax/jidoushazei/${jidoushazeiCd}`;
    if (kijunYmd) {
      url += `?q=kijunYmd=${kijunYmd}`;
    }
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getJidouTaxTable(kazeiKbn: string, shashuKbn: string, kijunYmd: string = '') {
    let url = `${apiUrlcommon}/tax/jidoushazei/getTaxTable?q=shashu%3D${shashuKbn},kazeiKbn%3D${kazeiKbn}`;
    if (kijunYmd) {
      url += `,kijunYmd=${kijunYmd}`;
    }
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getJidoushazeiTaxMonth(
    tax: any,
    date: string,
    month: number = 0,
    kijunYmd: string = '',
    taxRate: number = 0,
    zaikoItenKbn: number = 1
  ) {
    if (taxRate === 0) {
      taxRate = +this.taxRate.getValue();
    }
    const flag = this.allFlags.getValue();
    let inspection_flag = 1;
    if (flag) {
      inspection_flag = flag.shaken;
    }
    let url =
      `${apiUrlcommon}/tax/jidoushazei/getTaxMonthCalculate?q=` +
      `vehicleTax%3D${tax},yearMonthRegistCar%3D${date},inspection_flag=${inspection_flag},taxRate=${taxRate},zaikoItenKbn=${zaikoItenKbn},roundedKbn=${this.environmentSetting.getValue()}`;
    if (month > 0 && month < 13) url += `,vehicleTaxMonth=${month}`;
    if (kijunYmd) {
      url += `,kijunYmd=${kijunYmd}`;
    }
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getDOPKubuns() {
    const url = `${apiUrlcommon}/newcar/dealerOptions/optionKubuns`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getDealerOptions(grade: any, kbn: any, prefCd: string, tax: string = '80') {
    let url: string;
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);

    // url = 'http://localhost:3000/dealer';
    if (kbn != 0) {
      url = `${apiUrlcommon}/newcar/dealerOptionsGroupNm?q=makerCd%3D${
        grade.makerCd
      },modelCd%3D${grade.modelCd},kaiseiYm%3D${grade.kaiseiYm},gradeCd%3D${
        grade.gradeCd
      },prefCd%3D${prefCd},optionKbn%3D${kbn},taxRate=${tax}`;
    } else {
      url = `${apiUrlcommon}/newcar/dealerOptionsGroupNm?q=makerCd%3D${
        grade.makerCd
      },modelCd%3D${grade.modelCd},kaiseiYm%3D${grade.kaiseiYm},gradeCd%3D${
        grade.gradeCd
      },prefCd%3D${prefCd},taxRate=${tax}`;
    }

    return this.http
      .get(url, { headers })
      .map((response: Response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return [];
        }
      })
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  getKataruiSearch(katashikiCd: any, ruibetsuCd: any) {
    const url = `${apiUrlcommon}/car/katarui/v1?q=katashikiCd%3D${katashikiCd},ruibetsuCd%3D${ruibetsuCd}`;
    return this.httpGet(url, true);
  }

  getKataruiDetail(katashiki: any, ruibetsu: any, kataruiData: any) {
    const url =
      `${apiUrlcommon}/car/katarui/v1/detail1?q=` +
      `katashikiCd%3D${katashiki}` +
      `,ruibetsuCd%3D${ruibetsu}` +
      `,makerCd%3D${kataruiData.makerCd}` +
      `,modelCd%3D${kataruiData.modelCd}` +
      `,modelYear%3D${kataruiData.modelYear}` +
      `,gradeCd%3D${kataruiData.gradeCd}` +
      `,renban%3D${kataruiData.renban}`;
    return this.httpGet(url);
  }

  getKatashikiSearch(ninteikatashiki: string, tsushokatashiki: string) {
    let tsusho: string = null;
    if (tsushokatashiki) {
      tsusho = `${apiUrlcommon}/car/katashiki/v1?q=ninteikatashiki%3D${ninteikatashiki},tsushokatashiki%3D${tsushokatashiki}`;
    } else {
      tsusho = `${apiUrlcommon}/car/katashiki/v1?q=ninteikatashiki%3D${ninteikatashiki}`;
    }
    const url = tsusho;
    return this.httpGet(url, true);
  }

  getKatashikiDetail(katashiki: any) {
    const url =
      `${apiUrlcommon}/car/katashiki/v1/detail1?q=` +
      `makerCd%3D${katashiki.makerCd}` +
      `,modelCd%3D${katashiki.modelCd}` +
      `,modelYear%3D${katashiki.modelYear}` +
      `,gradeCd%3D${katashiki.gradeCd}` +
      `,renban%3D${katashiki.renban}`;
    return this.httpGet(url);
  }

  getSoubiData() {
    const url = `${apiUrlcommon}/etc/kbn/soubi`;
    return this.httpGet(url);
  }

  getShakenKigen() {
    const url = `${apiUrlcommon}/etc/kbn/shakenKigen`;
    return this.httpGet(url);
  }

  getKyotenData() {
    const kyoten: Kyotens = this.chosenKyoten.getValue();
    const url = `${apiUrl}/plan/bikou/masterList?q=kyotenCd=${kyoten.kyotenCd}`;
    return this.httpGet(url);
  }

  getDefaultBikou() {
    const kyoten: Kyotens = this.chosenKyoten.getValue();
    const url = `${apiUrl}/master/bikou/defaultItems?q=kyotenCd=${
      kyoten.kyotenCd
    }`;
    return this.httpGet(url);
  }

  getCreditCompany(): Observable<CreditCompany[]> {
    // const kyoten: Kyotens = this.chosenKyoten.getValue();
    const kyoten = this._data.kyotenCd;
    const url = `${apiUrl}/loan/creditCompanies?q=kyotenCd=${kyoten}`;
    return this.httpGet(url);
  }

  getLoanPlan(plantab, creditCompanyselect?): Observable<LoanPlan[]> {
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    const kyoten: Kyotens = this.chosenKyoten.getValue();
    let creditCompany = 0;
    if (plantab == 1 && !creditCompanyselect) {
      creditCompany = this.chosenCreditCompany.getValue();
    } else if (plantab == 2 && !creditCompanyselect) {
      creditCompany = this.chosenCreditCompany2.getValue();
    } else if (plantab == 3 && !creditCompanyselect) {
      creditCompany = this.chosenCreditCompany3.getValue();
    } else {
      creditCompany = creditCompanyselect;
    }
    return this.http
      .get(
        `${apiUrl}/loan/plans?q=kyotenCd=${
          kyoten.kyotenCd
        },shinpanKbn=${creditCompany}`,
        { headers: headers }
      )
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getLoanRate(plantab, CreditCompany?): Observable<LoanRate[]> {
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    const kyoten: Kyotens = this.chosenKyoten.getValue();
    let creditCompany = 0;
    let plan = 0;

    if (plantab === 1 && !CreditCompany) {
      creditCompany = this.chosenCreditCompany.getValue();
      plan = this.chosenLoanPlan.getValue();
    } else if (plantab === 2 && !CreditCompany) {
      creditCompany = this.chosenCreditCompany2.getValue();
      plan = this.chosenLoanPlan2.getValue();
    } else if (plantab === 3 && !CreditCompany) {
      creditCompany = this.chosenCreditCompany3.getValue();
      plan = this.chosenLoanPlan3.getValue();
    } else {
      creditCompany = CreditCompany;
      plan = this.chosenLoanPlan.getValue();
    }
    return this.http
      .get(
        `${apiUrl}/loan/plans/rates?q=kyotenCd=${
          kyoten.kyotenCd
        },shinpanKbn=${creditCompany},loanPlanKbn=${plan}`,
        {
          headers: headers
        }
      )
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getLoanPaymentCount(plantab): Observable<LoanPaymentCount[]> {
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    // const kyoten: Kyotens = this.chosenKyoten.getValue();
    let shinpanCode: string;
    let shinpanRenban: number;
    const kyoten = this._data.kyotenCd;
    // shinpanCode = this.chosenShinpanCode.getValue();
    // shinpanRenban = this.chosenShinpanRenban.getValue();
    let _shinpanCode;
    if (plantab === 1) {
      shinpanCode = this.chosenShinpanCode.getValue()
        ? this.chosenShinpanCode.getValue()
        : '0';
      shinpanRenban = this.chosenShinpanRenban.getValue();
    } else if (plantab === 2) {
      _shinpanCode = this.chosenShinpanCode2.getValue();
      shinpanRenban = this.chosenShinpanRenban2.getValue();
    } else if (plantab === 3) {
      _shinpanCode = this.chosenShinpanCode3.getValue();
      shinpanRenban = this.chosenShinpanRenban3.getValue();
    }
    shinpanCode = _shinpanCode ? _shinpanCode : '0';

    return this.http
      .get(
        `${apiUrl}/loan/plans/paymentCount?q=kyotenCd=${kyoten},shinpanCd=${shinpanCode},shinpanRenban=${shinpanRenban}`,
        { headers: headers }
      )
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getEnvironmentSetting(): Observable<EnvironmentSetting> {
    // const kyoten: Kyotens = this.chosenKyoten.getValue();
    const kyotenCd = this._data.kyotenCd;
    let url = `${apiUrl}/user/setting/environment`;
    if (kyotenCd) {
      url += `?q=kyotenCd=${kyotenCd}`;
    }
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getKappuGankin(atamaKin: number): Observable<KappuGankin> {
    const loanGankinKbn = this.loanGankinHasuuKbn.getValue();
    const grandTotal = this.currentGrandTotal.getValue();
    const url =
      `${apiUrlcommon}/loan/kappuGankin?q=` +
      `jissiSitaFlag=0,loanGankinHasuuKbn=${loanGankinKbn},atamaKin=${atamaKin},grandTotal=${grandTotal},is2WayLoan=0`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getNewKappuGankin(
    atamaKin: number,
    sueokiPrice: number,
    total?
  ): Observable<NewKappuGankin> {
    const kyoten = this.chosenKyoten.getValue().kyotenCd;
    let grandTotal = 0;

    if (total) {
      grandTotal = total;
    } else {
      grandTotal = this.currentGrandTotal.getValue();
    }
    const url =
      `${apiUrl}/loan/kappuGankin?q=` +
      `hanbaiKyotenCd=${kyoten},atamakin=${atamaKin},grandTotalPriceZk=${grandTotal},sueokiPrice=${sueokiPrice}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getInsuranceData() {
    const url = `${apiUrl}/plan/insuranceCompanies/masterList`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getMakerOption() {
    const url = `${apiUrlcommon}/newcar/makerOptions/optionKbn`;
    return (
      this.httpGet(url)
        .share()
        // .map(data => data.json())
        .catch(this.handleError.bind(this))
    );
  }

  getMakerOptionQuery(
    data: any,
    kbn: any,
    prefCd: string,
    tourokuYm: string,
    taxRate: number = 0
  ) {
    if (taxRate === 0) {
      taxRate = +this.taxRate.getValue();
    }
    let makerOptionQuery;
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);

    if (!data.kaiseiYm) {
      console.log('undefined', data.kaiseiYm);
      data.kaiseiYm = '201709';
    }
    if (kbn != '00') {
      makerOptionQuery = `${apiUrlcommon}/newcar/makerOptionsGroupNm?q=makerCd%3D${
        data.makerCd
      },modelCd%3D${data.modelCd},kaiseiYm%3D${data.kaiseiYm},gradeCd%3D${
        data.gradeCd
      },prefCd%3D${prefCd},optionKbn%3D${kbn},taxRate=${taxRate}`;
    } else {
      makerOptionQuery = `${apiUrlcommon}/newcar/makerOptionsGroupNm?q=makerCd%3D${
        data.makerCd
      },modelCd%3D${data.modelCd},kaiseiYm%3D${data.kaiseiYm},gradeCd%3D${
        data.gradeCd
      },prefCd%3D${prefCd},taxRate=${taxRate}`;
    }
    makerOptionQuery += `,tourokuYm=${tourokuYm}`;
    const url = makerOptionQuery;

    return this.http
      .get(url, { headers: headers })
      .map(response => {
        if (response.status !== 200) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .catch(this.handleJsonError.bind(this));
  }

  getShohiyouKazei(kyotenCd, tax, flags) {
    let url;
    if (
      flags &&
      Object.keys(flags).length > 0 &&
      Object.keys(flags).every(item => flags[item]) !== undefined
    ) {
      const {
        newCar,
        importCar,
        keiyon,
        shaken,
        kengaitouruku,
        shitadori,
        loan
      } = flags;
      url =
        `${apiUrl}/plan/shohiyou/kazei?q=` +
        `kyotenCd=${kyotenCd},taxRate=${tax},newCarFlg=${newCar},keiyonFlg=${keiyon},` +
        `importCarFlg=${importCar},shakenFlg=${shaken},kengaiTourokuFlg=${kengaitouruku},shitadoriFlg=${shitadori},loanFlg=${loan}`;
      return this.httpGet(url)
        .publishReplay()
        .refCount()
        .catch(this.handleError.bind(this));
    }
  }

  getShohiyouHikazei(kyotenCd, tax, flags) {
    let url;
    if (
      flags &&
      Object.keys(flags).length > 0 &&
      Object.keys(flags).every(item => flags[item]) !== undefined
    ) {
      const {
        newCar,
        importCar,
        keiyon,
        shaken,
        kengaitouruku,
        shitadori,
        loan
      } = flags;
      url =
        `${apiUrl}/plan/shohiyou/hikazei?q=` +
        `kyotenCd=${kyotenCd},taxRate=${tax},newCarFlg=${newCar},keiyonFlg=${keiyon},` +
        `importCarFlg=${importCar},shakenFlg=${shaken},kengaiTourokuFlg=${kengaitouruku},shitadoriFlg=${shitadori},loanFlg=${loan}`;

      return this.httpGet(url)
        .publishReplay()
        .refCount()
        .catch(this.handleError.bind(this));
    }
  }

  getkazeiHanbaiShohiyou(kazei: any) {
    const taxRate = this.taxRate.getValue();
    const url = `${apiUrl}/plan/kazeiHanbaiShohiyou/masterList?q=taxRate=${taxRate},kyotenCd%3D001,itemNo%3D${
      kazei.itemNo
    }`;
    return this.httpGet(url)
      .share()
      .catch(this.handleError.bind(this));
  }

  getHikazeiHanbaiShohiyou(hikazei: any) {
    const taxRate = this.taxRate.getValue();
    const url = `${apiUrl}/plan/hikazeiHanbaiShohiyou/masterList?q=taxRate=${taxRate},kyotenCd%3D001,itemNo%3D${
      hikazei.itemNo
    }`;
    return this.httpGet(url)
      .share()
      .catch(this.handleError.bind(this));
  }

  getFirstPaymentDate(isMmcLoan: number) {
    const baseYm = this.baseYearMonth.getValue();
    const url = `${apiUrlcommon}/loan/calcFirstPaymentDateYm?q=baseYm=${baseYm},isMmcLoan=${isMmcLoan}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getColorsDetail(data: any, tourokuYm: string) {
    const url =
      `${apiUrlcommon}/newcar/grades/colors/detail1?q=` +
      `makerCd%3D${data.makerCd}` +
      `,modelCd%3D${data.modelCd}` +
      `,kaiseiYm%3D${data.kaiseiYm}` +
      `,gradeCd%3D${data.gradeCd}` +
      `,colorCd%3D${encodeURIComponent(data.colorCd)}` +
      `,tourokuYm=${tourokuYm}`;
    return this.httpGet(url)
      .share()
      .catch(this.handleError.bind(this));
  }

  calCulateZeikomiToZeinuki(
    priceZk: number,
    taxRate: number = 0,
    roundedKbn: number = 0
  ) {
    if (taxRate === 0) {
      taxRate = +this.taxRate.getValue();
    }
    const url = `${apiUrlcommon}/tax/shouhizei/calcZeinuki?q=price=${priceZk},taxRate=${taxRate},roundedKbn=${this.environmentSetting.getValue()}`;
    return this.httpGet(url)
      .share()
      .catch(this.handleError.bind(this));
  }

  calCulateZeinukiToZeikomi(
    priceZn: number,
    taxRate: number = 0,
    roundedKbn: number = 0
  ) {
    if (taxRate === 0) {
      taxRate = +this.taxRate.getValue();
    }
    const url = `${apiUrlcommon}/tax/shouhizei/calcZeikomi?q=price=${priceZn},taxRate=${taxRate},roundedKbn=${this.environmentSetting.getValue()}`;
    return this.httpGet(url)
      .share()
      .catch(this.handleError.bind(this));
  }

  getNewcarDataDetail(grade: any, prefCd: number) {
    let kaiseiYm = null;
    if (!grade.kaiseiYm) {
      kaiseiYm = grade.gradeKaiseiYm;
    } else {
      kaiseiYm = grade.kaiseiYm;
    }
    const url =
      `${apiUrl}/newcar/detail?q=` +
      `prefCd=${prefCd},makerCd=${grade.makerCd},modelCd=${
        grade.modelCd
      },kaiseiYm=${kaiseiYm},gradeCd=${grade.gradeCd}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getLoanCalForOption(
    priceZk: number,
    kyotenCd: string,
    shinpanCd: string,
    shinpanRenban: number
  ) {
    const url =
      `${apiUrl}/loan/calculationForOptions?q=` +
      `priceZk%3D${priceZk},hanbaiKyotenCd%3D${kyotenCd},shinpanCd%3D${shinpanCd},shinpanRenban%3D${shinpanRenban}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getFirstBonusPaymentDate(
    bonusMonthOne: number,
    bonusMonthTwo: number,
    baseYm = ''
  ) {
    baseYm = baseYm === '' ? this.baseYearMonth.getValue() : baseYm;
    const url =
      `${apiUrlcommon}/loan/calcFirstBonusPaymentDateYm?q=` +
      `baseYm=${baseYm},bonusMonth1=${bonusMonthOne},bonusMonth2=${bonusMonthTwo}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getLoanCalculatedValue(
    gankin: number,
    kappuTesuuryouRitsu: string,
    paymentCount: number,
    bonusPayment: number,
    bonusPaymentCount: number,
    sueokiPrice: number,
    loankbn: number,
    systemFee: number,
    jisshitsuNenritsu: number
  ): Observable<LoanCalculatedValue> {
    const sougoukei = this.currentGrandTotal.getValue();
    const url =
      `${apiUrlcommon}/loan/calculate?q=` +
      `loanKbn=${loankbn}` +
      `,sougoukei=${sougoukei}` +
      `,sueokiKingaku=${sueokiPrice}` +
      `,gankin=${gankin}` +
      `,kappuTesuuryouRitsu=${kappuTesuuryouRitsu}` +
      `,paymentCount=${paymentCount}` +
      `,bonusPayment=${bonusPayment}` +
      `,bonusPaymentCount=${bonusPaymentCount}` +
      `,systemFee=${systemFee}` +
      `,jisshitsuNenritsu=${jisshitsuNenritsu}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getBonusPaymentCount(
    paymentCount: number,
    paymentStartYm: string,
    bonusPaymentStartYm: string,
    bonusMonthOne: number,
    bonusMonthTwo: number,
    loanKbn?: number
  ) {
    // if(!loanKbn){
    // const loankbn = this.chosenLoanPlan.getValue();
    // }
    const url =
      `${apiUrlcommon}/loan/calcBonusPaymentCount?q=` +
      `paymentCount=${paymentCount}` +
      `,loanKbn=${loanKbn}` +
      `,bonusMonth1=${bonusMonthOne}` +
      `,bonusMonth2=${bonusMonthTwo}` +
      `,paymentStartYm=${paymentStartYm}` +
      `,bonusPaymentStartYm=${bonusPaymentStartYm}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getSueokiPrice(
    calcOnZeikomi: number,
    sueokiRitsu: number
  ): Observable<Sueoki> {
    const kyoten = this.chosenKyoten.getValue();
    const hontaiZk = this.hontaiZk.getValue();
    const hontaiZn = this.hontaiZn.getValue();
    const url =
      `${apiUrl}/loan/sueokiKingaku?q=` +
      `hanbaiKyotenCd=${kyoten.kyotenCd}` +
      `,sueokiRitsu=${sueokiRitsu}` +
      `,calcOnZeikomi=${calcOnZeikomi}` +
      `,sharyouHontaiKakakuZk=${hontaiZk}` +
      `,sharyouHontaiKakakuZn=${hontaiZn}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getLeaseCalculateValue(
    param: LeaseCalcPriceParam
  ): Observable<any> {
    if (param.leaseKinri === 0) {
      return new Observable<any>(observer => {
        observer.next('leaseKinri=0');
      });
    }
    const headers = PlanService.headers;
    const kyoten = this.chosenKyoten.getValue();
    const leaseProviderId = param.leaseProviderId;
    const bonusKaisuu = param.bonusKaisuu;
    const bonusKasanKingaku = param.bonusKasanKingaku;
    const bonusKasanUmu = param.bonusKasanUmu;
    const carSoukouMonth = param.carSoukouMonth;
    const groupAddPriceAllZn = param.groupAddPriceAllZn;
    const groupAddPriceMonthZn = param.groupAddPriceMonthZn;
    const hikazeiTourokuHiyou = param.hikazeiTourokuHiyou;
    const hkHokenryouSougaku = param.hkHokenryouSougaku;
    const jibaisekiKingaku = param.jibaisekiKingaku;
    const jibaisekiKingaku_01 = param.jibaisekiKingaku_01;
    const jidoushazeiKingaku = param.jidoushazeiKingaku;
    const jidoushazeiKingaku_01 = param.jidoushazeiKingaku_01;
    const juuryouzeiKingaku = param.juuryouzeiKingaku;
    const juuryouzeiKingaku_01 = param.juuryouzeiKingaku_01;
    const kazeiTourokuHiyou = param.kazeiTourokuHiyou;
    const leaseKikan = param.leaseKikan;
    const leaseKinri = param.leaseKinri;
    const maeukekinKingaku = param.maeukekinKingaku;
    const mainPackPrice = param.mainPackPrice;
    const recyclePriceSum = param.recyclePriceSum;
    const shutokuzeiKingaku = this.shutokuZei.getValue();
    const sjFuzokuKingaku =
      this.sumDop.getValue() + this.sumHop.getValue() + this.sumMop.getValue();

    //▽[pl2021-41]add
    // オプション品合計税抜
    const hopTotalPriceZn = param.hopTotalPriceZn;
    const dopTotalPriceZn = param.dopTotalPriceZn;
    const mopTotalPriceZn = param.mopTotalPriceZn;
    //△[pl2021-41]add
    //▽[pl2021-53]add
    // オプション品環境性能割合計
    const dopKswTotal = param.dopKswTotal;
    const mopKswTotal = param.mopKswTotal;
    //△[pl2021-53]add

    const sjNebiki = param.sjNebiki;

    //▽[pl2021-10]add
    const sharyouKbn  = param.sharyouKbn;
    const bonusMonth1 = param.bonusKasanMonth1;
    const bonusMonth2 = param.bonusKasanMonth2;
    const bonusShokaiYm = param.bonusKasanShokaiYm;
    const tourokuYoteiYear = param.tourokuYoteiYear;
    const tourokuYoteiMonth = param.tourokuYoteiMonth;
    const useOptionalInsurance = param.useOptionalInsurance;
    const financeLeaseType = param.financeLeaseType;
    const endDisp = param.endDisp;
    const mentePackTotalZn = param.maintenancePlanTotalPriceZn;
    const csvJdzKingaku = param.csvJidoushazeiKingaku;
    const csvJrzKingaku = param.csvJuuryouzeiKingaku;
    const csvJbiKingaku = param.csvJibaisekiKingaku;
    //△[pl2021-10]add

    //▽[pl2021-19]add
    const jidoushazeiSetKey = param.jidoushazeiSetKey;
    //△[pl2021-19]add
    
    // this.discountPrice.getValue() < 0
    //   ? this.discountPrice.getValue() * -1
    //   : this.discountPrice.getValue();
    const sjSharyouKakaku = this.hontaiZk.getValue();
    const sjZankaKingaku = param.sjZankaKingaku;
    const totalPrice = this.currentGrandTotal.getValue();
    const productKbn = this.productKbn.getValue();

    //▽[pl2021-31]add
    const sjSharyouKakakuZn = this.hontaiZn.getValue();
    const kazeiTourokuHiyouZn = param.kazeiTourokuHiyouZn;
    //△[pl2021-31]add
    //▽[pl2021-38]add
    const mainteLeaseAddPriceZn = param.mainteLeaseAddPriceZn;
    //△[pl2021-38]add
    //▽[pl2021-44]add
    const shitadoriTotalZk = param.shitadoriTotalZk;
    const maeukekinAtamakinZk = param.maeukekinAtamakinZk;
    //△[pl2021-44]add
    //▽[pl2021-59]add
    const carTorokuYearF = param.carTorokuYearF;
    const carTorokuMonthF = param.carTorokuMonthF;
    const syakenUkewatasiFlg = param.syakenUkewatasiFlg;
    const carSyakenYear = param.carSyakenYear;
    const carSyakenMonth = param.carSyakenMonth;
    const carSyakenDay = param.carSyakenDay;
    //△[pl2021-59]add


    const url =
      `${apiUrl}/lease/calc/price?q=` +
      `leaseProviderId=${leaseProviderId}` +
      `,kyotenCd=${kyoten.kyotenCd}` +
      `,bonusKaisuu=${bonusKaisuu}` +
      `,bonusKasanKingaku=${bonusKasanKingaku}` +
      `,bonusKasanUmu=${bonusKasanUmu}` +
      `,carSoukouMonth=${carSoukouMonth}` +
      `,groupAddPriceAllZn=${groupAddPriceAllZn}` +
      `,groupAddPriceMonthZn=${groupAddPriceMonthZn}` +
      `,hikazeiTourokuHiyou=${hikazeiTourokuHiyou}` +
      `,hkHokenryouSougaku=${hkHokenryouSougaku}` +
      `,jibaisekiKingaku=${jibaisekiKingaku}` +
      `,jibaisekiKingaku_01=${jibaisekiKingaku_01}` +
      `,jidoushazeiKingaku=${jidoushazeiKingaku}` +
      `,jidoushazeiKingaku_01=${jidoushazeiKingaku_01}` +
      `,juuryouzeiKingaku=${juuryouzeiKingaku}` +
      `,juuryouzeiKingaku_01=${juuryouzeiKingaku_01}` +
      `,kazeiTourokuHiyou=${kazeiTourokuHiyou}` +
      `,leaseKikan=${leaseKikan}` +
      `,leaseKinri=${leaseKinri}` +
      `,shitadoriTotalZk=${shitadoriTotalZk}` +  //[pl2021-44]add
      `,maeukekinKingaku=${maeukekinKingaku}` +
      `,maeukekinAtamakinZk=${maeukekinAtamakinZk}` +  //[pl2021-44]add
      `,mainPackPrice=${mainPackPrice}` +
      `,recyclePriceSum=${recyclePriceSum}` +
      `,shutokuzeiKingaku=${shutokuzeiKingaku}` +
      `,sjFuzokuKingaku=${sjFuzokuKingaku}` +
      `,hopTotalPriceZn=${hopTotalPriceZn}` +    //[pl2021-41]add
      `,dopTotalPriceZn=${dopTotalPriceZn}` +    //[pl2021-41]add
      `,mopTotalPriceZn=${mopTotalPriceZn}` +    //[pl2021-41]add
      `,dopKswTotal=${dopKswTotal}` +            //[pl2021-53]add
      `,mopKswTotal=${mopKswTotal}` +            //[pl2021-53]add
      `,sjNebiki=${sjNebiki}` +
      `,sjSharyouKakaku=${sjSharyouKakaku}` +
      `,sjZankaKingaku=${sjZankaKingaku}` +
      `,totalPrice=${totalPrice}` +
      `,taxRate=${this.taxRate.getValue()}` +

      //▽[pl2021-10]add
      `,sharyouKbn=${sharyouKbn}` + 
      `,bonusMonth1=${bonusMonth1}` +      
      `,bonusMonth2=${bonusMonth2}` +      
      `,bonusShokaiYm=${bonusShokaiYm}` +      
      `,tourokuYoteiYear=${tourokuYoteiYear}` +      
      `,tourokuYoteiMonth=${tourokuYoteiMonth}` +      
      `,useNinniHoken=${useOptionalInsurance}` +      
      `,financeLeaseType=${financeLeaseType}` + 
      `,endDisp=${endDisp}` + 
      `,mentePackTotalZn=${mentePackTotalZn}` + 

      `,csvJidoushazeiKingaku=${csvJdzKingaku}` + 
      `,csvJuuryouzeiKingaku=${csvJrzKingaku}` + 
      `,csvJibaisekiKingaku=${csvJbiKingaku}` + 
      //△[pl2021-10]add
      //▽[pl2021-19]add
      `,jidoushazeiSetKey=${jidoushazeiSetKey}` + 
      //△[pl2021-19]add

    //▽[pl2021-31]add
    `,sjSharyouKakakuZn=${sjSharyouKakakuZn}` + 
    `,kazeiTourokuHiyouZn=${kazeiTourokuHiyouZn}` + 
    //△[pl2021-31]add

    //▽[pl2021-38]add
    `,mainteLeaseAddPriceZn=${mainteLeaseAddPriceZn}` + 
    //△[pl2021-38]add

    //▽[pl2021-59]add
    `,carTorokuYearF=${carTorokuYearF}` + 
    `,carTorokuMonthF=${carTorokuMonthF}` + 
    `,syakenUkewatasiFlg=${syakenUkewatasiFlg}` + 
    `,carSyakenYear=${carSyakenYear}` + 
    `,carSyakenMonth=${carSyakenMonth}` + 
    `,carSyakenDay=${carSyakenDay}` + 
    //△[pl2021-59]add
      `,productKbn=${productKbn}`;
    return this.httpGet(url);
  }

  getLeaseMaintenanceItem(
    mainteLeaseItem: string,
    leaseProviderId: number = 4,
    carData: car,
    carType: number,
    syakenCycleY2: string,
    kikan: number,
    jidoushazeiSetKey: string,  //[pl2021-61]add
    tourokuY: string,           //[pl2021-61]upd
    tourokuM: string,           //[pl2021-61]upd
  ): Observable<MaintenanceLeaseItem> {
    const kyoten = this.chosenKyoten.getValue();
    const productKbn = this.productKbn.getValue();
    let url =
      `${apiUrl}/lease/maintenance/item?q=` +
      `leaseProviderId=${leaseProviderId}` +
      `,kyotenCd=${kyoten.kyotenCd}` +
      `,mainteLeaseItem=${mainteLeaseItem}` +
      `,taxRate=${this.taxRate.getValue()}` +
      `,carType=${carType}` +
      `,syakenCycleY2=${syakenCycleY2}` +
      `,productKbn=${productKbn}`;
      if (tourokuY && tourokuM) {
        url += `,tourokuY=${tourokuY},tourokuM=${tourokuM}`;
      }
      if (carData.nenshiki) {
        const carTorokuYearF = carData.nenshiki.substr(0, 4);
        let carTorokuMonthF = carData.nenshiki.substr(4, 2);
        url += `,carTorokuYearF=${carTorokuYearF}`;
        if (carTorokuMonthF !== '') {
          carTorokuMonthF = (+carTorokuMonthF).toString();
          url += `,carTorokuMonthF=${carTorokuMonthF}`;
        }
      } else if (carType > 1) {
        url += ',carTorokuYearF=,carTorokuMonthF=';
      }
      if (carData.shakenKigenYmd) {
        const carSyakenYear = carData.shakenKigenYmd.substr(0, 4);
        let carSyakenMonth = carData.shakenKigenYmd.substr(4, 2);
        let carSyakenDate = carData.shakenKigenYmd.substr(6, 2);
        url += `,carSyakenYear=${carSyakenYear}`;
        if (carSyakenMonth !== '') {
          carSyakenMonth = (+carSyakenMonth).toString();
          url += `,carSyakenMonth=${carSyakenMonth}`;
        }
        if (carSyakenDate !== '') {
          carSyakenDate = (+carSyakenDate).toString();
          url += `,carSyakenDate=${carSyakenDate}`;
        }
      } else if (carType > 1) {
        url += ',carSyakenYear=,carSyakenMonth=,carSyakenDate=';
      }
      if (carData.shakenUmuKbn != null || carType > 1) {
        const syakenUkewatasiFlg = carData.shakenUmuKbn === 0 ? 1 : 0;
        url += `,syakenUkewatasiFlg=${syakenUkewatasiFlg}`;
      }

      if (kikan) {
        url += `,leaseKikan=${kikan}`;
      }

      //▽[pl2021-61]add
      url += `,jidoushazeiSetKey=${jidoushazeiSetKey}`;
      //△[pl2021-61]add

    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getShadaiBangouAreaKanji() {
    const url = `${apiUrlcommon}/etc/shadaiBangouAreaKanji/list`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getPlateAreas() {
    const url = `${apiUrlcommon}/car/plateAreas`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getShitadoriPrice(
    type: number,
    shadaino: string,
    kanjishadaiareacd: number,
    kanjishadaicd: string,
    kanjishadaino: number,
    plateareacd: number,
    plateshashu: string,
    platekana: string,
    plateno: string,
    iskaicar: number,
    onhaisha: number,
    hasaircon: number,
    hasairbag: number
  ) {
    if (type == 0) {
      if (onhaisha == 1) {
        const url = `${apiUrlcommon}/etc/recycle/payments?q=shadaiNoIncludesKanji=${type},shadaiNo=${shadaino},plateAreaCd=${plateareacd},plateShashu=${plateshashu},plateKana=${encodeURIComponent(
          platekana
        )},plateNo=${plateno},isKeiCar=${iskaicar},onHaisha=${onhaisha},hasAircon=${hasaircon},hasAirbag=${hasairbag}`;
        return this.httpGet(url, true).catch(this.handleError.bind(this));
      } else {
        const url = `${apiUrlcommon}/etc/recycle/payments?q=shadaiNoIncludesKanji=${type},shadaiNo=${shadaino},plateAreaCd=${plateareacd},plateShashu=${plateshashu},plateKana=${encodeURIComponent(
          platekana
        )},plateNo=${plateno},isKeiCar=${iskaicar},onHaisha=${onhaisha}`;
        return this.httpGet(url, true).catch(this.handleError.bind(this));
      }
    } else if (type == 1) {
      if (onhaisha == 1) {
        const url = `${apiUrlcommon}/etc/recycle/payments?q=shadaiNoIncludesKanji=${type},kanjiShadaiAreaCd=${kanjishadaiareacd},kanjiShadaiNo=${kanjishadaino},kanjiShadaiCd=${kanjishadaicd},plateAreaCd=${plateareacd},plateShashu=${plateshashu},plateKana=${encodeURIComponent(
          platekana
        )},plateNo=${plateno},isKeiCar=${iskaicar},onHaisha=${onhaisha},hasAircon=${hasaircon},hasAirbag=${hasairbag}`;
        return this.httpGet(url, true).catch(this.handleError.bind(this));
      } else {
        const url = `${apiUrlcommon}/etc/recycle/payments?q=shadaiNoIncludesKanji=${type},kanjiShadaiAreaCd=${kanjishadaiareacd},kanjiShadaiNo=${kanjishadaino},kanjiShadaiCd=${kanjishadaicd},plateAreaCd=${plateareacd},plateShashu=${plateshashu},plateKana=${encodeURIComponent(
          platekana
        )},plateNo=${plateno},isKeiCar=${iskaicar},onHaisha=${onhaisha}`;
        return this.httpGet(url, true).catch(this.handleError.bind(this));
      }
    }

    // const url = `${apiUrlcommon}/etc/recycle/payments?q=shadaiNoIncludesKanji=2,kanjiShadaiAreaCd=岡,kanjiShadaiNo=32020,kanjiShadaiCd=74,plateAreaCd=岡山,plateShashu=580,plateKana=う,plateNo=1,isKeiCar=2,onHaisha=2,hasAircon=1,hasAirbag=1`;
    // return this.httpGet(url);
  }

  private httpGet(url: string, isGetStatus: boolean = false) {
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    // headers.set('auth', '81wNWIkOCO+4ezPJrDx9dDL+QRJORTZ3Ys26cwMizkk=');
    return this.http
      .get(url, { headers: headers })
      .map(response => {
        // if (response.status === 401) {
        //   console.log('response.status');
        //   console.log(response.status);
        //   this.clearDataAndNavigateToLogin();
        // } else {
        if (isGetStatus && response.status != 200) {
          this.setResponseStatus(response.status);
        } else {
          this.setResponseStatus(0);
        }
        return response.json();
        // }
      })
      .catch(this.handleError.bind(this));
  }

  deleteToken() {
    const token = this._data.token;
    const headers = PlanService.headers;
    headers.set('auth', token);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this.http
        .delete(`${apiUrl}/auth/token`, { headers: PlanService.headers })
        .subscribe(() => {});
    }
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    // console.error(error.status);
    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(errMsg);
    }
  }

  private handleJsonError(error: Response | any) {
    let res = error;
    if (error instanceof Response) {
      res = error.json();
    }
    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(res);
    }
  }

  getSoubi(soubi: any[]) {
    return (this.soubiData = soubi);
  }

  setResponseStatus(res) {
    this.ResponseStatus = res;
  }

  setPlanTab(tab) {
    this.plantab = tab;
    return Observable.of(this.plantab);
  }

  getJibaiseki(isnewcar, add1month, targetdate) {
    const url = `${apiUrlcommon}/tax/jibaiseki/paymentTable?q=isNewCar=${isnewcar},add1Month=${add1month},targetDate=${targetdate}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getJibaisekiKingaku(jibaisekiCd, month) {
    const url = `${apiUrlcommon}/tax/jibaiseki/kingaku/${jibaisekiCd}/${month}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getJibaisekiMonth(
    jibaisekiCd,
    sharyouKbn,
    shakenKigenYmd,
    tourokuYm,
    isShaken,
    weightTaxCd
  ) {
    const kyoten = this.chosenKyoten.getValue().kyotenCd;
    let url = `${apiUrl}/tax/jibaiseki/month?q=tourokuYm=${tourokuYm},isShaken=${isShaken},hanbaiKyotenCd=${kyoten}`;
    if (jibaisekiCd != null) {
      url += `,jibaisekiCd=${jibaisekiCd}`;
    }
    if (sharyouKbn != null) {
      url += `,sharyouKbn=${sharyouKbn}`;
    }
    if (shakenKigenYmd != null) {
      url += `,shakenKigenYmd=${shakenKigenYmd}`;
    }
    if (weightTaxCd != null) {
      url += `,weightTaxCd=${weightTaxCd}`;
    }
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    this.behaviorNextnull();
    this.router.navigate(['/login']);
  }

  ongetStockDetail(shatenCd, kanriNo) {
    const path = `${apiUrl}/plan/stock?q=kanriNo%3D${kanriNo},taxRate%3D${this.taxRate.getValue()},salesKyotenCd%3D${
      this._data.kyotenCd
    },shatenCd%3D${shatenCd}`;
    return this.httpGet(path).catch(this.handleError.bind(this));
  }

  carComplementModelCd(makerNm: string, modelNm: string) {
    const path = `${apiUrlcommon}/car/complementModelCd?q=makerNm=${makerNm},modelNm=${modelNm}`;
    return this.httpGet(path).catch(this.handleError.bind(this));
  }

  ongetBtobStockPlanFormat(enKei: string, enFutsuu: string, enImport: string, inputZaikoId: any = null) {
    const zaikoId = this._data.btobZaikoId || inputZaikoId;
    let path = `${apiUrl}/btob/stocks/${zaikoId}/planFormat?q=taxRate=${this.taxRate.getValue()},kyotenCd=${
      this._data.kyotenCd},additionalPrice=${enKei},${enFutsuu},${enImport}`;
    
    return this.httpGet(path).catch(this.handleError.bind(this));
  }

  getHanbai() {
    const url = `${apiUrlcommon}/etc/kbn/hanbai`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getPlate() {
    const url = `${apiUrlcommon}/etc/kbn/plate`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getnyuukoBunrui() {
    const url = `${apiUrl}/master/nyuukoBunrui`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getsytemfee(
    loanKbn,
    jisshitsuNenritsu,
    sueokiKingaku,
    kameitenTesuuryouRitsu
  ) {
    // /loan/calcSystemRiyouhi?q=loanKbn=2,jisshitsuNenritsu=3.9,sueokiKingaku=820000
    const url = `${apiUrlcommon}/loan/calcSystemRiyouhi?q=loanKbn%3D${loanKbn},jisshitsuNenritsu%3D${jisshitsuNenritsu},sueokiKingaku%3D${sueokiKingaku},kameitenTesuuryouRitsu%3D${kameitenTesuuryouRitsu}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  getCalculatedLoan(data) {
    if (data.isSueokiPlan === 1) {
      return this.getsytemfee(
        data.loanKbn,
        data.jisshitsuNenritsu,
        data.sueokiPrice,
        data.kameitenTesuuryouRitsu
      ).switchMap(val =>
        this.getLoanCalculatedValue(
          data.gankin,
          data.selectedPaymentCount.kappuTesuuryouRitsu,
          data.paymentCounts,
          data.bonusPayment,
          data.bonusPaymentCount,
          data.sueokiPrice,
          data.loanKbn,
          val.systemRiyouhi,
          data.jisshitsuNenritsu
        )
      );
    } else {
      return this.getLoanCalculatedValue(
        data.gankin,
        data.selectedPaymentCount.kappuTesuuryouRitsu,
        data.paymentCounts,
        data.bonusPayment,
        data.bonusPaymentCount,
        data.sueokiPrice,
        data.loanKbn,
        0,
        data.jisshitsuNenritsu
      );
    }
  }

  getLaborRatePrice(kyotenCd, makerCd) {
    const url = `${apiUrl}/master/laborRate/${kyotenCd}/${makerCd}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  async mapPriceWhenTaxChange(items, tax, callback?) {
    console.log('in function', items);
    let input;
    input = items.map(data => ({ ...data }));

    const cb = input.map(async item => {
      const kouchinZkRes = await this.calCulateZeinukiToZeikomi(
        +item.kouchinZn,
        +tax
      ).toPromise();
      const priceZkRes = await this.calCulateZeinukiToZeikomi(
        +item.priceZn,
        +tax
      ).toPromise();
      const priceZk = +priceZkRes.zeikomi;
      const kouchinZk = +kouchinZkRes.zeikomi;
      const priceZnRes = await this.calCulateZeikomiToZeinuki(
        priceZk,
        +tax
      ).toPromise();
      const kouchinZnRes = await this.calCulateZeikomiToZeinuki(
        kouchinZk,
        +tax
      ).toPromise();
      const priceZn = +priceZnRes.zeinuki;
      const kouchinZn = +kouchinZnRes.zeinuki;
      return {
        ...item,
        priceZk,
        priceZn,
        kouchinZk,
        kouchinZn
      };
    });
    console.log('cb: ', cb);
    Promise.all(cb).then(results => {
      console.log('results: ', results);

      callback(results);
    });

    // input.map(async (item, i) => {
    //   // if (item.priceZn === 0 || item.kouchinZn === 0) {
    //   //   return [];
    //   // }
    //   kouchinZkRes = await this.calCulateZeinukiToZeikomi(+item.kouchinZn, +tax).toPromise();
    //   priceZkRes = await this.calCulateZeinukiToZeikomi(+item.priceZn, +tax).toPromise();
    //   item.priceZk = +priceZkRes.zeikomi;
    //   item.kouchinZk = +kouchinZkRes.zeikomi;
    //   priceZnRes = await this.calCulateZeikomiToZeinuki(item.priceZk, +tax).toPromise();
    //   kouchinZnRes = await this.calCulateZeikomiToZeinuki(item.kouchinZk, +tax).toPromise();
    //   item.priceZn = +priceZnRes.zeinuki;
    //   item.kouchinZn = +kouchinZnRes.zeinuki;
    //   console.log('inputt', input);
    //   callback(input);
    // });
  }

  mapKazeiForSave(shohiyouKazei: ShohiyouKazei[]) {
    let saveKazei = {};
    const items = [];
    shohiyouKazei.forEach(shohiyou => {
      items.push({
        itemNm: shohiyou.kazeiNm,
        priceZk: +shohiyou.kazeiPriceZk,
        priceZn: +shohiyou.kazeiPriceZn
      });
    });
    saveKazei = {
      ...saveKazei,
      isHikazei: this.switchPriceShohiyo.getValue() === 'ZK' ? 0 : 1,
      items,
      subTotalZk: shohiyouKazei.reduce(
        (acc, cur) => acc + +cur.kazeiPriceZk,
        0
      ),
      subTotalZn: shohiyouKazei.reduce((acc, cur) => acc + +cur.kazeiPriceZn, 0)
    };
    return saveKazei;
  }

  mapHikazeiForSave(shohiyouHikazei: ShohiyouHikazei[]) {
    let saveHikazei = {};
    const items = [];
    shohiyouHikazei.forEach(shohiyou => {
      items.push({
        itemNm: shohiyou.hikazeiNm,
        price: +shohiyou.hikazeiPriceZN
      });
    });
    saveHikazei = {
      ...saveHikazei,
      items,
      subTotal: shohiyouHikazei.reduce(
        (acc, cur) => acc + +cur.hikazeiPriceZN,
        0
      )
    };
    return saveHikazei;
  }

  behaviorNextnull() {
    this.fromSaveOnly.next('');
    this.chosenMakerChange.next('');
    this.chosenModelChange.next('');
    this.chosenSoukouValue.next('');
    this.chosenBikouValue.next('');
    this.chosenItenValue.next(0);
    this.chosenColorSelected.next('');
    this.chosenShiftSelected.next('');
    this.chosenFuelSelected.next(0);
    this.chosenShashuSelected.next(0);
    this.chosenClearState.next('');
    this.chosenClearAll.next('');
    this.chosenJidouValue.next('');
    this.chosenJuuryouValue.next('');
    this.chosenGradeSelected.next('');
    this.chosenDealerItemSelected.next('');
    this.chosenDealerItemUnselected.next('');
    this.chosenGradeSelectedforDOP.next('');
    this.chosenKataruiDetail.next('');
    this.chosenKatashikiDetail.next('');
    this.chosenPriceZk.next('');
    this.chosenPriceZn.next('');
    this.chosenShakenKigenKbn.next('');
    this.chosenKyoten.next(null);
    this.changeKyoten.next(false);
    this.chosenInsurance.next('');
    this.chosenClearFlag.next('');
    this.chosenMakerOption.next('');
    this.baseYearMonth.next('');
    this.chosenNewCarData.next('');
    this.chosenNewCarColor.next('');
    this.chosenKazeiShohiyou.next('');
    this.newcarDefaultShohiyouCd.next('');
    this.usedcarDefaultShohiyouCd.next('');
    this.getNiihokinData.next('');
    this.getNiihokinChecked.next('');
    this.currentGrandTotal.next(0);
    this.grandTotalLoan.next(0);
    this.grandTotalLease.next(0);
    this.hontaiZk.next(0);
    this.hontaiZn.next(0);
    this.chosenHiKazeiShohiyou.next('');
    this.setMopDataFilter.next('');
    this.setPlanMaker.next('');
    this.setPlanDealer.next('');
    this.kataruiSelected.next('');
    this.katashikiSelected.next('');
    this.chosenPrefCd.next('');
    this.jibaisekiKikanIkkagetsuKasan.next('');
    this.deleteFlagDOP.next('');
    this.deleteFlagHOP.next('');
    this.deleteFlagMOP.next('');
    this.setMOPItem.next('');
    this.deleteFlagSpecialColor.next(false);
    this.flagNewCarColorDetail.next(false);
    this.passingPlanUsedcar.next('');
    this.chosenjibaiseki.next(null);
    this.chosenjuuryouzeiPayment.next(null);
    this.chosenPaymentMethod.next(null);
    this.chosenPaymentMethod2.next(null);
    this.chosenPaymentMethod3.next(null);

    this.chosenCreditCompany.next(0);
    this.chosenLoanPlan.next(0);
    this.chosenShinpanCode.next('');
    this.chosenShinpanRenban.next(0);
    this.loanGankinHasuuKbn.next(0);
    this.isPlanOneActivated.next(false);
    this.isPlanTwoActivated.next(false);
    this.loanOneAtamakin.next(0);
    this.loanTwoAtamakin.next(0);
    this.loanPlanOneName.next('');
    this.loanPlanTwoName.next('');
    this.loanOneMonthlyPayment.next(0);
    this.loanTwoMonthlyPayment.next(0);
    this.loanOneFirstPayment.next(0);
    this.loanTwoFirstPayment.next(0);
    this.loanOneBonus.next(0);
    this.loanTwoBonus.next(0);
    this.loanOneBonusCount.next(0);
    this.loanTwoBonusCount.next(0);
    this.loanOnePaymentCount.next(0);
    this.loanOnePaymentCount2.next(0);
    this.loanOnePaymentCount3.next(0);
    this.loanTwoPaymentCount.next(0);
    this.loanTwoPaymentCount2.next(0);
    this.loanTwoPaymentCount3.next(0);
    this.loanOneFirstPaymentYM.next('');
    this.loanTwoFirstPaymentYM.next('');
    this.loanOneKappuTesuuRyou.next(0);
    this.loanTwoKappuTesuuRyou.next(0);
    this.loanOneBonusMonthOne.next(0);
    this.loanTwoBonusMonthOne.next(0);
    this.loanOneBonusMonthTwo.next(0);
    this.loanTwoBonusMonthTwo.next(0);
    this.loanOneShinpanRenban.next(0);
    this.loanTwoShinpanRenban.next(0);
    this.loanOneShinpanCode.next('');
    this.loanTwoShinpanCode.next('');
    this.loanOneFirstBonusPaymentYM.next('');
    this.loanTwoFirstBonusPaymentYM.next('');
    this.loanOneIsSueoki.next(0);
    this.loanTwoIsSueoki.next(0);
    this.loanOneSueokiPrice.next(0);
    this.loanTwoSueokiPrice.next(0);
    this.loanOneSueokiRitsu.next(0);
    this.loanTwoSueokiRitsu.next(0);
    this.isShowBalloon.next(false);
    this.setNewCarColorDetail.next('');
    this.chosenCreditCompany2.next(0);
    this.chosenLoanPlan2.next(0);
    this.chosenShinpanCode2.next('');
    this.chosenShinpanRenban2.next(0);
    this.loanOneAtamakin2.next(0);
    this.loanTwoAtamakin2.next(0);
    this.loanPlanOneName2.next('');
    this.loanPlanTwoName2.next('');
    this.loanOneMonthlyPayment2.next(0);
    this.loanTwoMonthlyPayment2.next(0);
    this.loanOneFirstPayment2.next(0);
    this.loanTwoFirstPayment2.next(0);
    this.loanOneBonus2.next(0);
    this.loanTwoBonus2.next(0);
    this.loanOneBonusCount2.next(0);
    this.loanTwoBonusCount2.next(0);
    this.isShowBalloon2.next(false);
    this.loanOneFirstPaymentYM2.next('');
    this.loanTwoFirstPaymentYM2.next('');
    this.loanOneKappuTesuuRyou2.next(0);
    this.loanTwoKappuTesuuRyou2.next(0);
    this.loanOneBonusMonthOne2.next(0);
    this.loanTwoBonusMonthOne2.next(0);
    this.loanOneBonusMonthTwo2.next(0);
    this.loanTwoBonusMonthTwo2.next(0);
    this.loanOneShinpanRenban2.next(0);
    this.loanTwoShinpanRenban2.next(0);
    this.loanOneShinpanCode2.next('');
    this.loanTwoShinpanCode2.next('');
    this.loanOneFirstBonusPaymentYM2.next('');
    this.loanTwoFirstBonusPaymentYM2.next('');
    this.loanOneIsSueoki2.next(0);
    this.loanTwoIsSueoki2.next(0);
    this.loanOneSueokiPrice2.next(0);
    this.loanTwoSueokiPrice2.next(0);
    this.loanOneSueokiRitsu2.next(0);
    this.loanTwoSueokiRitsu2.next(0);
    this.loanOnePaymentCount2.next(0);
    this.loanTwoPaymentCount2.next(0);
    this.chosenCreditCompany3.next(0);
    this.chosenLoanPlan3.next(0);
    this.chosenShinpanCode3.next('');
    this.chosenShinpanRenban3.next(0);
    this.loanOneAtamakin3.next(0);
    this.loanTwoAtamakin3.next(0);
    this.loanPlanOneName3.next('');
    this.loanPlanTwoName3.next('');
    this.loanOneMonthlyPayment3.next(0);
    this.loanTwoMonthlyPayment3.next(0);
    this.loanOneFirstPayment3.next(0);
    this.loanTwoFirstPayment3.next(0);
    this.loanOneBonus3.next(0);
    this.loanTwoBonus3.next(0);
    this.loanOneBonusCount3.next(0);
    this.loanTwoBonusCount3.next(0);
    this.isShowBalloon3.next(false);
    this.loanOneFirstPaymentYM3.next('');
    this.loanTwoFirstPaymentYM3.next('');
    this.loanOneKappuTesuuRyou3.next(0);
    this.loanTwoKappuTesuuRyou3.next(0);
    this.loanOneBonusMonthOne3.next(0);
    this.loanTwoBonusMonthOne3.next(0);
    this.loanOneBonusMonthTwo3.next(0);
    this.loanTwoBonusMonthTwo3.next(0);
    this.loanOneShinpanRenban3.next(0);
    this.loanTwoShinpanRenban3.next(0);
    this.loanOneShinpanCode3.next('');
    this.loanTwoShinpanCode3.next('');
    this.loanOneFirstBonusPaymentYM3.next('');
    this.loanTwoFirstBonusPaymentYM3.next('');
    this.loanOneIsSueoki3.next(0);
    this.loanTwoIsSueoki3.next(0);
    this.loanOneSueokiPrice3.next(0);
    this.loanTwoSueokiPrice3.next(0);
    this.loanOneSueokiRitsu3.next(0);
    this.loanTwoSueokiRitsu3.next(0);
    this.loanOnePaymentCount3.next(0);
    this.loanTwoPaymentCount3.next(0);
    this.shutokuZei.next(0);

    this.gradeSelectedplan.next(null);
    this.datachosennotax.next(null);
    this.datachosennotaxation.next(null);
    this.isInitialPlan = false;
    this.isInitialLease = false;
    this.selectPaymentWay.next(null);
    this.leaseShohiyouKazei.next([]);
    this.leaseShohiyouHikazei.next([]);
    this.leaseShohiyouKazei2.next([]);
    this.leaseShohiyouHikazei2.next([]);
    this.leaseShohiyouKazei3.next([]);
    this.leaseShohiyouHikazei3.next([]);
    this.shohiyouKazeiPrice.next(0);
    this.shohiyouHikaazeiPrice.next(0);
    this.discountPrice.next(0);
    this.sumHop.next(0);
    this.sumDop.next(0);
    this.sumMop.next(0);
    this.customernamesub.next(null);
    this.switchCustomer.next(null);
    this.isNewCar.next(0);
    this.allFlags.next(null);
    this.switchLoanDOP.next('');
    this.loanMonth.next(0);
    this.savedLaborRatePrice.next(0);
  }

  onresetloan() {
    this.isShowBalloon.next(false);
    this.isInitialPlan = true;
    this.chosenCreditCompany.next(0);
    this.loanCreditCompanyOne.next(0);
    this.loanCreditCompanyTwo.next(0);
    this.loanchosenLoanPlanOne.next(0);
    this.loanchosenLoanPlanTwo.next(0);
    this.chosenLoanPlan.next(0);
    this.chosenShinpanCode.next('');
    this.chosenShinpanRenban.next(0);
    this.loanGankinHasuuKbn.next(0);
    this.isPlanOneActivated.next(true);
    this.isPlanTwoActivated.next(false);
    this.loanOneAtamakin.next(0);
    this.loanTwoAtamakin.next(0);
    this.loanPlanOneName.next('');
    this.loanPlanTwoName.next('');
    this.loanOneMonthlyPayment.next(0);
    this.loanTwoMonthlyPayment.next(0);
    this.loanOneFirstPayment.next(0);
    this.loanTwoFirstPayment.next(0);
    this.loanOneBonus.next(0);
    this.loanTwoBonus.next(0);
    this.loanOneBonusCount.next(0);
    this.loanTwoBonusCount.next(0);
    this.loanOnePaymentCount.next(0);
    this.loanTwoPaymentCount.next(0);
    this.loanOneFirstPaymentYM.next('');
    this.loanTwoFirstPaymentYM.next('');
    this.loanOneKappuTesuuRyou.next(0);
    this.loanTwoKappuTesuuRyou.next(0);
    this.loanOneBonusMonthOne.next(0);
    this.loanTwoBonusMonthOne.next(0);
    this.loanOneBonusMonthTwo.next(0);
    this.loanTwoBonusMonthTwo.next(0);
    this.loanOneShinpanRenban.next(0);
    this.loanTwoShinpanRenban.next(0);
    this.loanOneShinpanCode.next('');
    this.loanTwoShinpanCode.next('');
    this.loanOneFirstBonusPaymentYM.next('');
    this.loanTwoFirstBonusPaymentYM.next('');
    this.loanOneIsSueoki.next(0);
    this.loanTwoIsSueoki.next(0);
    this.loanOneSueokiPrice.next(0);
    this.loanTwoSueokiPrice.next(0);
    this.loanOneSueokiRitsu.next(0);
    this.loanTwoSueokiRitsu.next(0);
    this.chosenPaymentMethod.next(null);
    this.chosenPaymentMethod2.next(null);
    this.chosenPaymentMethod3.next(null);
  }

  calTotalRecycle(
    recycle,
    recycleRyoukinAzukariAtsukai: number,
    taxRate: number
  ) {
    const promise1 = new Promise((resolve, reject) => {
      let shredderDust = 0,
        airBag = 0,
        freonKind = 0,
        jyouhouKanri = 0,
        shikinKanri = 0;
      if (recycle.shredderDust) {
        shredderDust = this._util.stringToNumber(recycle.shredderDust);
      }
      if (recycle.airBag) {
        airBag = this._util.stringToNumber(recycle.airBag);
      }
      if (recycle.freonKind) {
        freonKind = this._util.stringToNumber(recycle.freonKind);
      }
      if (recycle.jyouhouKanri) {
        jyouhouKanri = this._util.stringToNumber(recycle.jyouhouKanri);
      }
      if (recycle.shikinKanri) {
        shikinKanri = this._util.stringToNumber(recycle.shikinKanri);
      }
      recycle.totalZk =
        shredderDust + airBag + freonKind + jyouhouKanri + shikinKanri;

      if (recycle.totalZk) {
        if (recycleRyoukinAzukariAtsukai === 1 && recycle.yotakuKbn === 0) {
          recycle.totalZn = recycle.totalZk;
          resolve(recycle);
        } else {
          if (recycle.shikinKanri == null) {
            recycle.shikinKanri = 0;
          }
          this.calCulateZeikomiToZeinuki(
            recycle.shikinKanri,
            taxRate
          ).subscribe(res => {
            if (res) {
              recycle.totalZn =
                shredderDust + airBag + freonKind + jyouhouKanri + res.zeinuki;
              resolve(recycle);
            } else {
              reject(null);
            }
          });
        }
      } else {
        recycle.totalZn = 0;
        resolve(recycle);
      }
    });
    return promise1;
  }

  public checkLeaseCarMakerEnabled(leaseProviderId: number, sharyouKbn: number, makerCd: string) {
    const url = `${apiUrl}/lease/car/maker/enabled?q=leaseProviderId=${leaseProviderId},sharyouKbn=${sharyouKbn},makerCd=${makerCd}`;
    return this.httpGet(url);
  }

  // api for usedcar laease
  private getFindGradeParam(param: any) {
    let arrQ = [];
    Object.keys(param).forEach((key: string) => {
      if (param[key]) {
        arrQ.push(`${key}=${param[key]}`);
      }
    });
    return arrQ.join(',');
  }
  findGradeList(param: {kata?: string, rui?: string, makerCd?: string, modelCd?: string,
    kaiseiYm?: string, gradeNm?: string, katashiki?: string, driveKbn?: string,
    displacement?: string, shiftNm?: string}) {
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    const q = this.getFindGradeParam(param);
    return this.http
      .get(`${apiUrlcommon}/findGradeV2?q=${q}`, {
        headers: headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  findGradeModelList(param: {kata?: string, rui?: string, makerCd?: string, modelCd?: string, modelNm?: string}) {
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    const q = this.getFindGradeParam(param);
    return this.http
      .get(`${apiUrlcommon}/findGrade/model?q=${q}`, {
        headers: headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getFindGradeFilter(key: string, param: { makerCd?: string, modelCd?: string,
    kaiseiYm?: string, kata?: string, rui?: string }) {
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    const q = this.getFindGradeParam(param);
    return this.http
      .get(`${apiUrlcommon}/findGrade/${key}?q=${q}`, {
        headers: headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getLeaseInit(
    getMode: number,
    grade: any,
    kyoten: any,
    creditCompany: any,
    carData: car,
    carType: number,
    customerKbn: number,
    tourokuY?: string,
    tourokuM?: string,
    endDispKbn?: string,
    kikan?: string,
    souko?: string,
    ritouKbn: number = 0,
  ): Observable<CompanyList>  {
    const productKbn = this.productKbn.getValue();
    let url =
      `${apiUrl}/lease/init?q=` +
      `getMode=${getMode}` +
      `,carType=${carType}` +
      `,leaseProviderId=${creditCompany}` +
      `,kyotenCd%3D${kyoten.kyotenCd}` +
      `,makerCd%3D${grade.makerCd}` +
      `,modelCd%3D${grade.modelCd}` +
      `,kaiseiYm%3D${grade.kaiseiYm}` +
      `,gradeCd%3D${grade.gradeCd}` +
      `,taxRate=${this.taxRate.getValue()}` +
      `,productKbn=${productKbn}` +
      `,customerKbn=${customerKbn}`;
    if (tourokuY && tourokuM) {
      url += `,tourokuY=${tourokuY},tourokuM=${tourokuM}`;
    }
    if (carData.nenshiki) {
      const carTorokuYearF = carData.nenshiki.substr(0, 4);
      let carTorokuMonthF = carData.nenshiki.substr(4, 2);
      url += `,carTorokuYearF=${carTorokuYearF}`;
      if (carTorokuMonthF !== '') {
        carTorokuMonthF = (+carTorokuMonthF).toString();
        url += `,carTorokuMonthF=${carTorokuMonthF}`;
      }
    }
    if (carData.shakenKigenYmd) {
      const carSyakenYear = carData.shakenKigenYmd.substr(0, 4);
      let carSyakenMonth = carData.shakenKigenYmd.substr(4, 2);
      url += `,carSyakenYear=${carSyakenYear}`;
      if (carSyakenMonth !== '') {
        carSyakenMonth = (+carSyakenMonth).toString();
        url += `,carSyakenMonth=${carSyakenMonth}`;
      }
    }
    if (carData.shakenUmuKbn != null) {
      const syakenUkewatasiFlg = carData.shakenUmuKbn === 0 ? 1 : 0;
      url += `,syakenUkewatasiFlg=${syakenUkewatasiFlg}`;
    }
    if (carData.priceZk) {
      url += `,carPriceIntax=${carData.priceZk}`;
    }

    if (getMode === 2) {
      url += `,leaseEndDispKbn=${endDispKbn}` +
      `,leaseKikan=${kikan}` +
      `,leaseSouko=${souko}` +
      `,ritouKbn=${ritouKbn}`;
    }
    //▽[pl2021-57]add
    url += `,carPriceZn=${carData.priceZn}`;
    //△[pl2021-57]add

    return this.httpGet(url, true).catch(this.handleError.bind(this));
  }

  getLeaseCarType(sharyouKbn: number) {
    const url = `${apiUrl}/lease/kbn/carType/fromSharyouKubun/${sharyouKbn}`;
    return this.httpGet(url).catch(this.handleError.bind(this));
  }

  findGradeCheckModelKeys(param: {kata?: string, rui?: string, nenshiki?: string,
    makerCd?: string, modelCd?: string, makerNm?: string, modelNm?: string }) {
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);
    const q = this.getFindGradeParam(param);
    return this.http
      .get(`${apiUrlcommon}/findGrade/checkModelKeysV2?q=${q}`, {
        headers: headers
      })
      .map(response => response.json())
      .catch(this.handleError.bind(this));
  }

  getShouhizeiList() {
    const url = `${apiUrlcommon}/tax/shouhizei/list`;
    return this.httpGet(url)
      .share()
      .catch(this.handleError.bind(this));
  }

  //▽[pl2021-72]add
  /**
   * [新車]自賠責情報を得るためにInitAPIを叩く
   */
  requestLeaseInitForJibaisekiDetailNewCar(
    leaseProviderId:number,
    kyotenCd:string,
    makerCd:string,
    modelCd:string,
    kaiseiYm:string,
    gradeCd:string,
    productKbn:number,
    customerKbn:number,
    endDispKbn:number,
    kikan:number,
    souko:number,
    ritouKbn:number,
    taxRate:string,
    tourokuY:string,
    tourokuM:string
  ) {
    // 自賠責に関係無い部分は固定値とする
    const sharyouHontaiKakakuZk = 5500000;
    const sharyouHontaiKakakuZn = 5000000;

    // その他固定値
    const getMode = 2;
    const carType = 1;  // 新車

    let url =
      `${apiUrl}/lease/init?q=` +
      `getMode=${getMode}` +
      `,carType=${carType}` +
      `,leaseProviderId=${leaseProviderId}` +
      `,kyotenCd%3D${kyotenCd}` +
      `,makerCd%3D${makerCd}` +
      `,modelCd%3D${modelCd}` +
      `,kaiseiYm%3D${kaiseiYm}` +
      `,gradeCd%3D${gradeCd}` +
      `,taxRate=${taxRate}` +
      `,productKbn=${productKbn}` +
      `,customerKbn=${customerKbn}`;
    url += `,tourokuY=${tourokuY},tourokuM=${tourokuM}`;
    url += `,leaseEndDispKbn=${endDispKbn}` +
    `,leaseKikan=${kikan}` +
    `,leaseSouko=${souko}` +
    `,ritouKbn=${ritouKbn}`;


    url += `,carPriceIntax=${sharyouHontaiKakakuZk}`;
    url += `,carPriceZn=${sharyouHontaiKakakuZn}`;

    return this.httpGet(url, true).catch(this.handleError.bind(this));
  }
  //△[pl2021-72]add

  //▽[pl2021-72]add
  /**
   * [中古車]自賠責情報を得るためにInitAPIを叩く
   */
   requestLeaseInitForJibaisekiDetailUsedCar(
    leaseProviderId:number,
    kyotenCd:string,
    makerCd:string,
    modelCd:string,
    kaiseiYm:string,
    gradeCd:string,
    productKbn:number,
    customerKbn:number,
    endDispKbn:number,
    kikan:number,
    souko:number,
    ritouKbn:number,
    taxRate:string,
    tourokuY:string,
    tourokuM:string,
    nenshiki:string,
    shakenKigenYmd:string,
    shakenUmuKbn:number
  ) {
    // 自賠責に関係無い部分は固定値とする
    const sharyouHontaiKakakuZk = 5500000;
    const sharyouHontaiKakakuZn = 5000000;

    // その他固定値
    const getMode = 2;
    const carType = 3;  // リース基準 ... 3:中古車

    let url =
      `${apiUrl}/lease/init?q=` +
      `getMode=${getMode}` +
      `,carType=${carType}` +
      `,leaseProviderId=${leaseProviderId}` +
      `,kyotenCd%3D${kyotenCd}` +
      `,makerCd%3D${makerCd}` +
      `,modelCd%3D${modelCd}` +
      `,kaiseiYm%3D${kaiseiYm}` +
      `,gradeCd%3D${gradeCd}` +
      `,taxRate=${taxRate}` +
      `,productKbn=${productKbn}` +
      `,customerKbn=${customerKbn}`;
    url += `,tourokuY=${tourokuY},tourokuM=${tourokuM}`;

    if (nenshiki) {
      const carTorokuYearF = nenshiki.substr(0, 4);
      let carTorokuMonthF = nenshiki.substr(4, 2);
      url += `,carTorokuYearF=${carTorokuYearF}`;
      if (carTorokuMonthF !== '') {
        carTorokuMonthF = (+carTorokuMonthF).toString();
        url += `,carTorokuMonthF=${carTorokuMonthF}`;
      }
    }
    if (shakenKigenYmd) {
      const carSyakenYear = shakenKigenYmd.substr(0, 4);
      let carSyakenMonth = shakenKigenYmd.substr(4, 2);
      url += `,carSyakenYear=${carSyakenYear}`;
      if (carSyakenMonth !== '') {
        carSyakenMonth = (+carSyakenMonth).toString();
        url += `,carSyakenMonth=${carSyakenMonth}`;
      }
    }
    if (shakenUmuKbn != null) {
      const syakenUkewatasiFlg = shakenUmuKbn === 0 ? 1 : 0;
      url += `,syakenUkewatasiFlg=${syakenUkewatasiFlg}`;
    }

    url += `,leaseEndDispKbn=${endDispKbn}` +
    `,leaseKikan=${kikan}` +
    `,leaseSouko=${souko}` +
    `,ritouKbn=${ritouKbn}`;


    url += `,carPriceIntax=${sharyouHontaiKakakuZk}`;
    url += `,carPriceZn=${sharyouHontaiKakakuZn}`;

    return this.httpGet(url, true).catch(this.handleError.bind(this));
  }
  //△[pl2021-72]add


  //▽[2021-09-08 kyuwa #7394]add: 新車デリバリーでの画面制御追加
  /**
   * 新車デリバリーのユーザーかどうかを得る
   */
   async isNewCarDeliveryUser():Promise<boolean> {
    // 担当者ログインされていたらその拠点コードを得る
    let kyotenCd = (this._data.kyotenCd ? this._data.kyotenCd : "");
    
    // APIから情報を得る
    let apiResponse:any;
    try {
      apiResponse = await this.requestHomeSettingToApi(kyotenCd).toPromise();
    } catch (e) {
      console.log("Error at isNewCarDeliveryUser.",e);
      throw new Error("契約サービス情報を取得できませんでした(" + e.message +")");
    }
    if (apiResponse == null) {
      throw new Error("契約サービス情報を取得できませんでした");
    }

    // 結果の判定
    let result = false;
    if (apiResponse.ncDeliveryState == "1") {
      result = true;
    }
    return result;
  }
  //△[2021-09-08 kyuwa #7394]add: 新車デリバリーでの画面制御追加


  //▽[2021-09-08 kyuwa #7394]add: 新車デリバリーでの画面制御追加
  /**
   * 契約サービス情報を得る(新車市場、コレCARラ、新車デリバリー)
   * (例外は呼出元で処理)
   */
  requestHomeSettingToApi(kyotenCd:string):Observable<Response> {
    // APIリクエスト
    const headers = PlanService.headers;
    headers.set('auth', this._data.token);

    let url = `${apiUrl}/user/setting/home`;
    // 拠点コード指定時はその拠点の設定を得る
    if (kyotenCd != "") {
      url += `?q=kyotenCd=${kyotenCd}`;
    }

    return this.http
      .get(url, {headers: headers})
      .map(response => {
        return response.json();
      });
  }
  //△[2021-09-08 kyuwa #7394]add: 新車デリバリーでの画面制御追加


}



// WEBPACK FOOTER //
// ./src/app/services/plan.service.ts